// ==========================================
// COMPLETE mockData.js - ALL EXPORTS
// Replace your entire src/utils/mockData.js with this file
// ==========================================

// Staffing domain mock data (FST.2–FST.6)
export * from './staffingMockData';

// ==========================================
// USER DATA
// ==========================================
export const mockUser = {
  id: 'user-001',
  name: 'Sarah Chen',
  title: 'RN, Nurse Manager',
  unit: '4 West',
  unitId: 'unit-4w',
  serviceLineId: 'primary-care',
  lastLogin: 'Today at 8:32 AM'
};

// ==========================================
// PRIORITY QUEUE DATA (Sprint 2: includes checklist items; questions attached by api)
// ==========================================
export const mockPriorityQueueData = [
  {
    id: 'queue-cl-001',
    type: 'checklist',
    checklistId: 'cl-001',
    checklistName: 'Daily Medication Fridge Temperature Check',
    description: 'Check and log temperature readings',
    category: 'Safety Compliance',
    dueDate: new Date(new Date().setHours(9, 0, 0, 0)).toISOString(),
    estimatedTime: 5,
    priority: 'critical',
    status: 'pending',
    questions: []
  },
  {
    id: 'queue-cl-002',
    type: 'checklist',
    checklistId: 'cl-002',
    checklistName: 'Weekly Supply Inventory Count',
    description: 'Count and document supplies',
    category: 'Inventory',
    dueDate: new Date(new Date().setHours(14, 0, 0, 0)).toISOString(),
    estimatedTime: 15,
    priority: 'high',
    status: 'pending',
    questions: []
  },
  {
    id: 'task-001',
    type: 'task',
    title: 'Complete diabetic A1C outreach for 12 patients',
    category: 'Quality Metrics',
    dueDate: new Date().toISOString(),
    estimatedTime: 45,
    priority: 'critical',
    impact: 'High - affects monthly quality score',
    status: 'pending'
  },
  {
    id: 'task-002',
    type: 'task',
    title: 'Review and dispose of expired RSV vaccines in Fridge A-3',
    category: 'Medication Safety',
    dueDate: new Date(new Date().getTime() + 86400000).toISOString(),
    estimatedTime: 20,
    priority: 'high',
    impact: 'Safety compliance required',
    status: 'pending'
  },
  {
    id: 'task-003',
    type: 'task',
    title: 'Coordinate PM shift coverage for Thursday (2 RN call-outs)',
    category: 'Staffing',
    dueDate: new Date(new Date().getTime() + 172800000).toISOString(),
    estimatedTime: 30,
    priority: 'medium',
    impact: 'Patient safety - staffing ratio',
    status: 'pending'
  }
];

// ==========================================
// QUALITY METRICS DATA
// ==========================================
export const mockQualityMetricsData = [
  {
    id: 'metric-1',
    name: 'Diabetic A1C Control',
    current: 68,
    target: 75,
    trend: 'down',
    status: 'below'
  },
  {
    id: 'metric-2',
    name: 'Post-Discharge Follow-up',
    current: 85,
    target: 80,
    trend: 'up',
    status: 'above'
  },
  {
    id: 'metric-3',
    name: 'Medication Adherence',
    current: 72,
    target: 80,
    trend: 'neutral',
    status: 'below'
  }
];

// ==========================================
// STAFFING DATA
// ==========================================
export const mockStaffingData = {
  today: {
    scheduled: 12,
    callOuts: 2,
    actual: 10,
    needed: 11,
    status: 'short'
  }
};

// ==========================================
// CONSUMER INSIGHTS — Unit definitions
// ==========================================
export const mockConsumerUnits = [
  { id: 'all', name: 'All Units', mobName: null },
  { id: 'unit-main-st', name: 'Main St Clinic', mobName: 'Eastside MOB' },
  { id: 'unit-oak-park', name: 'Oak Park Family', mobName: 'Eastside MOB' },
  { id: 'unit-riverside', name: 'Riverside Urgent', mobName: 'Westside MOB' },
];

// ==========================================
// EXECUTIVE DASHBOARD DATA
// ==========================================
export const mockExecutiveDashboardData = {
  kpis: {
    serviceLineAverage: 84,
    trend: 6,
    unitsOnTrack: 9,
    totalUnits: 12,
    needsAttention: 3
  },
  topPerformers: [
    {
      id: 'unit-5n',
      name: '5 North',
      manager: 'Jennifer Martinez',
      score: 92,
      highlight: 'Excellent diabetic care metrics'
    },
    {
      id: 'unit-3w',
      name: '3 West',
      manager: 'David Chen',
      score: 89,
      highlight: 'Outstanding patient satisfaction'
    }
  ],
  needsAttention: [
    {
      id: 'unit-11e',
      name: '11 East',
      manager: 'Michael Brown',
      score: 69,
      target: 75,
      issue: 'Quality metrics below target'
    }
  ],
  keyInsights: [
    {
      title: 'Diabetic Care Trending Down',
      description: 'Service line average for A1C control dropped from 75% to 68%.'
    }
  ],
  upcomingPriorities: [
    { text: 'Monthly Quality Review Meeting', dueDate: 'Feb 5' }
  ]
};

// ==========================================
// ACCESS METRICS DATA (POLISHED)
// ==========================================
export const mockAccessMetricsData = {
  sameDayRate: 78,
  sameDayTarget: 85,
  sameDayTrend: 3,
  sameDayThisWeek: 156,
  avgWaitDays: 4.2,
  waitTarget: 3,
  openSlots: 23,
  providers: 8,
  backlog: 47,
  oldestRequest: 12,
  waitByType: {
    primary: 3.1,
    specialty: 6.8,
    urgent: 0.5
  },
  providerAvailability: [
    { id: 1, name: 'Dr. Sarah Johnson', specialty: 'Primary Care', openSlots: 5, booked: 11, total: 16 },
    { id: 2, name: 'Dr. Michael Chen', specialty: 'Primary Care', openSlots: 3, booked: 13, total: 16 },
    { id: 3, name: 'Dr. Emily Rodriguez', specialty: 'Cardiology', openSlots: 7, booked: 9, total: 16 },
    { id: 4, name: 'Dr. James Wilson', specialty: 'Internal Medicine', openSlots: 2, booked: 10, total: 12 },
    { id: 5, name: 'Dr. Lisa Anderson', specialty: 'Family Medicine', openSlots: 6, booked: 14, total: 20 }
  ]
};

// ==========================================
// STAFFING ALERTS DATA (POLISHED)
// ==========================================
export const mockStaffingAlertsData = {
  criticalAlerts: 2,
  upcomingRisks: 3,
  floatRequests: {
    pending: 2,
    fulfilled: 5,
    failed: 1
  },
  currentCoverage: 89,
  staffNeeded: 18,
  staffScheduled: 16,
  activeAlerts: [
    {
      id: 'alert-001',
      severity: 'critical',
      title: 'PM Shift Coverage Gap - 2 RNs Short',
      timeframe: 'Today, 3:00 PM - 11:00 PM',
      description: '2 call-outs for PM shift (3p-11p). Currently short 2 RNs. Patient load: 24 patients.',
      impact: 'High patient-to-nurse ratio (12:1 vs target 6:1). Safety concern.',
      recommendation: 'Request float pool immediately. Consider mandatory overtime or shift extension for AM staff.'
    },
    {
      id: 'alert-002',
      severity: 'critical',
      title: 'Float Pool Request Failed - ICU Overflow',
      timeframe: 'Today, 7:00 PM - 7:00 AM',
      description: 'Float pool request for night shift was denied due to system-wide shortage. ICU overflow needs coverage.',
      impact: 'Unable to accommodate ICU overflow patients without additional staff.',
      recommendation: 'Contact house supervisor. Review patient assignments.'
    }
  ]
};

// ==========================================
// WEEKLY PRIORITIES DATA
// ==========================================
export const mockWeeklyPrioritiesData = {
  author: 'Director Martinez',
  postedDate: 'Monday 8:00 AM',
  primaryFocus: "Diabetic care outreach needs our attention this week.",
  urgentReminder: "RSV vaccines in Fridge A-3 expire on January 25th (Friday).",
  staffingNote: "Next week's schedule has some gaps for PM shifts (Tue/Thu).",
  celebration: "Great work last week on preventive care screenings!"
};

// ==========================================
// PERFORMANCE DISTRIBUTION DATA
// ==========================================
export const mockPerformanceDistributionData = {
  units: [
    { id: '11E', name: '11E', overallScore: 69, qualityScore: 69, performanceLevel: 'critical' },
    { id: '10W', name: '10W', overallScore: 72, qualityScore: 72, performanceLevel: 'belowTarget' },
    { id: '5N', name: '5N', overallScore: 92, qualityScore: 88, performanceLevel: 'excellent' }
  ],
  summary: { excellent: 2, onTrack: 4, belowTarget: 2, critical: 1 }
};

// ==========================================
// PHASE 3: ROLES DATA
// ==========================================
export const mockRoles = [
  {
    id: 'role-super-1',
    name: 'System Administrator',
    level: 'superuser',
    description: 'Full system access',
    visibleMetrics: ['Quality Metrics', 'Access Metrics', 'Staffing Alerts'],
    permissions: {
      viewDashboard: true,
      editData: true,
      manageUsers: true,
      configureSystem: true,
      createChecklists: true,
      manageRoles: true
    },
    userCount: 2,
    isSystem: true,
    createdDate: 'Jan 2026'
  }
];

// ==========================================
// SPRINT 2: CHECKLISTS DATA (advanced schedule + questions)
// ==========================================
export const mockChecklists = [
  {
    id: 'cl-001',
    name: 'Daily Medication Fridge Temperature Check',
    description: 'Check and log temperature readings for medication storage fridges',
    status: 'active',
    questions: [
      { id: 'q1', type: 'checkbox', label: 'Fridge A temperature logged?', required: true, order: 1 },
      { id: 'q2', type: 'number', label: 'Fridge A temperature reading (°F)', required: true, min: 36, max: 40, order: 2 },
      { id: 'q3', type: 'checkbox', label: 'Fridge B temperature logged?', required: true, order: 3 },
      { id: 'q4', type: 'number', label: 'Fridge B temperature reading (°F)', required: true, min: 36, max: 40, order: 4 },
      { id: 'q5', type: 'text', label: 'Any concerns or issues?', required: false, placeholder: 'Enter any concerns here...', order: 5 }
    ],
    schedule: {
      frequency: 'daily',
      timeOfDay: '09:00',
      priority: 'critical',
      startDate: '2026-02-01'
    },
    createdBy: 'user-001',
    createdAt: '2026-01-15T10:00:00Z'
  },
  {
    id: 'cl-002',
    name: 'Weekly Supply Inventory Count',
    description: 'Count and document supplies to ensure adequate stock levels',
    status: 'active',
    questions: [
      { id: 'q1', type: 'number', label: 'Gloves (boxes)', required: true, min: 0, order: 1 },
      { id: 'q2', type: 'number', label: 'Masks (boxes)', required: true, min: 0, order: 2 },
      { id: 'q3', type: 'number', label: 'Syringes (boxes)', required: true, min: 0, order: 3 },
      { id: 'q4', type: 'checkbox', label: 'All items above minimum par levels?', required: true, order: 4 },
      { id: 'q5', type: 'text', label: 'Items needing reorder', required: false, placeholder: 'List items below par...', order: 5 }
    ],
    schedule: {
      frequency: 'weekly',
      daysOfWeek: [1, 5],
      timeOfDay: '14:00',
      priority: 'high',
      startDate: '2026-02-01'
    },
    createdBy: 'user-001',
    createdAt: '2026-01-20T14:30:00Z'
  },
  {
    id: 'cl-003',
    name: 'Monthly Safety Equipment Inspection',
    description: 'Inspect all safety equipment on the second Tuesday of each month',
    status: 'active',
    questions: [
      { id: 'q1', type: 'checkbox', label: 'Fire extinguisher present and charged?', required: true, order: 1 },
      { id: 'q2', type: 'checkbox', label: 'Emergency exit signs illuminated?', required: true, order: 2 },
      { id: 'q3', type: 'checkbox', label: 'First aid kit stocked?', required: true, order: 3 },
      { id: 'q4', type: 'checkbox', label: 'Eyewash station functional?', required: true, order: 4 },
      { id: 'q5', type: 'checkbox', label: 'AED present and functional?', required: true, order: 5 },
      { id: 'q6', type: 'text', label: 'Issues requiring immediate attention', required: false, placeholder: 'Describe any safety concerns...', order: 6 }
    ],
    schedule: {
      frequency: 'monthly',
      monthlyPattern: 'weekday',
      weekOfMonth: 'second',
      dayOfWeekForMonthly: 2,
      timeOfDay: '10:00',
      priority: 'high',
      startDate: '2026-02-01'
    },
    createdBy: 'user-001',
    createdAt: '2026-01-10T09:00:00Z'
  }
];

// ==========================================
// SPRINT 2: CHECKLIST SUBMISSIONS (array)
// ==========================================
export const mockChecklistSubmissions = [
  {
    id: 'sub-001',
    checklistId: 'cl-001',
    checklistName: 'Daily Medication Fridge Temperature Check',
    submittedBy: 'Sarah Chen',
    submittedAt: '2026-02-02T09:15:00Z',
    status: 'completed',
    responses: [
      { questionId: 'q1', type: 'checkbox', value: true, answeredAt: '2026-02-02T09:10:00Z' },
      { questionId: 'q2', type: 'number', value: 38.2, answeredAt: '2026-02-02T09:12:00Z' },
      { questionId: 'q3', type: 'checkbox', value: true, answeredAt: '2026-02-02T09:13:00Z' },
      { questionId: 'q4', type: 'number', value: 37.8, answeredAt: '2026-02-02T09:14:00Z' },
      { questionId: 'q5', type: 'text', value: 'All normal', answeredAt: '2026-02-02T09:15:00Z' }
    ],
    completionTime: 5
  }
];

// ==========================================
// PHASE 3: ORG HIERARCHY
// ==========================================
export const mockOrgHierarchy = {
  markets: [
    { id: 'mkt-1', name: 'Mid-Atlantic Market', code: 'MA', active: true }
  ],
  regions: [
    { id: 'reg-1', name: 'Columbia Medical Center', marketId: 'mkt-1', code: 'CMC', active: true }
  ],
  buildings: [
    { id: 'bld-1', name: '4 West Medical Office', regionId: 'reg-1', address: '10710 Charter Dr, Columbia, MD', active: true }
  ],
  serviceLines: [
    { id: 'sl-1', name: 'Primary Care', code: 'PC', regionId: 'reg-1', active: true }
  ]
};

// ==========================================
// SPRINT 3: DAILY FOCUS ISSUES (Story 1)
// ==========================================
export const mockDailyFocusIssues = [
  {
    id: 'issue-001',
    title: 'Diabetic A1C Below Target (68%)',
    description: 'Current: 68% | Target: 75% | Gap: -7%',
    source: 'quality',
    priority: 'high',
    impact: 'Affects monthly quality score',
    dueDate: '2026-02-15',
    estimatedTime: 45,
    sourceData: { id: 'metric-1', name: 'Diabetic A1C Control', current: 68, target: 75 }
  },
  {
    id: 'issue-002',
    title: 'PM Shift Coverage Gap - 2 RNs Short',
    description: '2 call-outs for PM shift. Currently short 2 RNs.',
    source: 'staffing',
    priority: 'critical',
    impact: 'Patient safety - staffing ratio at risk',
    dueDate: '2026-02-02',
    estimatedTime: 30,
    sourceData: {}
  },
  {
    id: 'issue-003',
    title: 'Same-Day Access Below Target (78%)',
    description: 'Current: 78% | Target: 85% | Gap: -7%',
    source: 'access',
    priority: 'medium',
    impact: 'Patient access metrics',
    dueDate: '2026-02-28',
    estimatedTime: 60,
    sourceData: {}
  },
  {
    id: 'issue-004',
    title: 'Medication Adherence Below Target (72%)',
    description: 'Current: 72% | Target: 80%',
    source: 'quality',
    priority: 'medium',
    impact: 'Quality metrics',
    dueDate: '2026-02-20',
    estimatedTime: 90,
    sourceData: {}
  },
  {
    id: 'issue-005',
    title: 'Negative Sentiment - 10% of reviews',
    description: '125 negative reviews in period',
    source: 'consumer',
    priority: 'low',
    impact: 'Consumer insights',
    dueDate: '2026-03-01',
    estimatedTime: 45,
    sourceData: {}
  }
];

// ==========================================
// SPRINT 3: PERFORMANCE BUCKETS (Story 2)
// ==========================================
export const mockPerformanceBuckets = [
  {
    id: 'quality',
    name: 'Quality',
    score: 78,
    target: 75,
    trend: -5,
    unit: '%',
    facilities: [
      { id: 'facility-001', name: '4 West Medical Unit', location: 'Main Campus', score: 82 },
      { id: 'facility-002', name: '5 East Surgical', location: 'Main Campus', score: 74 },
      { id: 'facility-003', name: 'North Clinic', location: 'North Site', score: 78 }
    ]
  },
  {
    id: 'service',
    name: 'Service',
    score: 82,
    target: 80,
    trend: 3,
    unit: '%',
    facilities: [
      { id: 'facility-001', name: '4 West Medical Unit', location: 'Main Campus', score: 85 },
      { id: 'facility-002', name: '5 East Surgical', location: 'Main Campus', score: 79 },
      { id: 'facility-003', name: 'North Clinic', location: 'North Site', score: 82 }
    ]
  },
  {
    id: 'access',
    name: 'Access',
    score: 74,
    target: 85,
    trend: -8,
    unit: '%',
    facilities: [
      { id: 'facility-001', name: '4 West Medical Unit', location: 'Main Campus', score: 82 },
      { id: 'facility-002', name: '5 East Surgical', location: 'Main Campus', score: 68 },
      { id: 'facility-003', name: 'North Clinic', location: 'North Site', score: 71 }
    ]
  },
  {
    id: 'staffing',
    name: 'Staffing',
    score: 89,
    target: 90,
    trend: -2,
    unit: '%',
    facilities: [
      { id: 'facility-001', name: '4 West Medical Unit', location: 'Main Campus', score: 92 },
      { id: 'facility-002', name: '5 East Surgical', location: 'Main Campus', score: 85 },
      { id: 'facility-003', name: 'North Clinic', location: 'North Site', score: 89 }
    ]
  },
  {
    id: 'finance',
    name: 'Finance',
    score: 94,
    target: 90,
    trend: 4,
    unit: '%',
    facilities: [
      { id: 'facility-001', name: '4 West Medical Unit', location: 'Main Campus', score: 96 },
      { id: 'facility-002', name: '5 East Surgical', location: 'Main Campus', score: 91 },
      { id: 'facility-003', name: 'North Clinic', location: 'North Site', score: 94 }
    ]
  },
  {
    id: 'consumer',
    name: 'Consumer',
    score: 81,
    target: 80,
    trend: 2,
    unit: '%',
    facilities: [
      { id: 'facility-001', name: '4 West Medical Unit', location: 'Main Campus', score: 84 },
      { id: 'facility-002', name: '5 East Surgical', location: 'Main Campus', score: 78 },
      { id: 'facility-003', name: 'North Clinic', location: 'North Site', score: 81 }
    ]
  }
];

// ==========================================
// SPRINT 4: INITIATIVES (Director creates → Manager sees as Assignments)
// ==========================================
export const mockInitiatives = [
  {
    id: 'init-001',
    name: 'Reduce ED Wait Times',
    description: 'Target 15-minute reduction in average wait',
    assignedUnit: '4 West',
    assignedManager: 'Sarah Chen',
    assignedTo: 'user-001',
    priority: 'high',
    status: 'pending',
    targetDate: '2026-03-15'
  },
  {
    id: 'init-002',
    name: 'Flu Vaccination Push',
    description: 'Achieve 90% staff vaccination rate by end of month',
    assignedUnit: '5 North',
    assignedManager: 'Jennifer Martinez',
    assignedTo: 'user-002',
    priority: 'critical',
    status: 'in-progress',
    targetDate: '2026-02-28'
  }
];

// ==========================================
// SPRINT 3: ASSIGNMENTS (Story 4)
// ==========================================
export const mockAssignments = [
  {
    id: 'assign-001',
    title: 'Submit Q1 Performance Report',
    description: 'Comprehensive report covering all metrics for Q1. Include financial summary, quality YoY comparison, and staffing analysis.',
    assignedTo: 'user-001',
    assignedBy: 'director-001',
    assignedByName: 'Director Chen',
    assignedByRole: 'director',
    dueDate: '2026-02-15T17:00:00Z',
    priority: 'high',
    status: 'in-progress',
    requirements: [
      { id: 'req-1', text: 'Financial summary', completed: false },
      { id: 'req-2', text: 'Quality metrics YoY comparison', completed: true },
      { id: 'req-3', text: 'Staffing analysis', completed: false }
    ],
    attachments: [{ name: 'Q1_Template.xlsx', url: '/files/template.xlsx' }],
    createdAt: '2026-02-01T10:00:00Z',
    completedAt: null
  },
  {
    id: 'assign-002',
    title: 'Staffing Plan Update for Q2',
    description: 'Update staffing plan and submit for VP review.',
    assignedTo: 'user-001',
    assignedBy: 'vp-001',
    assignedByName: 'VP Martinez',
    assignedByRole: 'vp',
    dueDate: '2026-02-22T17:00:00Z',
    priority: 'medium',
    status: 'not-started',
    requirements: [
      { id: 'req-1', text: 'Draft staffing plan', completed: false },
      { id: 'req-2', text: 'Get unit manager sign-off', completed: false }
    ],
    attachments: [],
    createdAt: '2026-02-02T09:00:00Z',
    completedAt: null
  }
];

// ==========================================
// SPRINT 4: DIRECTOR 6-PILLAR DASHBOARD DATA
// ==========================================
export const mockDirectorDrilldownOptions = {
  Region: [
    { id: 'region-primary-care', label: 'Primary Care' },
    { id: 'region-specialty-care', label: 'Specialty Care' }
  ],
  MOB: {
    'region-primary-care': [
      { id: 'mob-cardiology', label: 'Cardiology' },
      { id: 'mob-orthopedics', label: 'Orthopedics' },
      { id: 'mob-oncology', label: 'Oncology' }
    ],
    'region-specialty-care': [
      { id: 'mob-neurology', label: 'Neurology' },
      { id: 'mob-dermatology', label: 'Dermatology' },
      { id: 'mob-pulmonology', label: 'Pulmonology' }
    ]
  },
  'Service Line': {
    'mob-cardiology': [
      { id: 'service-line-interventional-cardiology', label: 'Interventional Cardiology' },
      { id: 'service-line-electrophysiology', label: 'Electrophysiology' }
    ],
    'mob-orthopedics': [
      { id: 'service-line-joint-replacement', label: 'Joint Replacement' },
      { id: 'service-line-sports-medicine', label: 'Sports Medicine' }
    ],
    'mob-oncology': [
      { id: 'service-line-radiation-oncology', label: 'Radiation Oncology' },
      { id: 'service-line-medical-oncology', label: 'Medical Oncology' }
    ],
    'mob-neurology': [
      { id: 'service-line-stroke', label: 'Stroke Care' },
      { id: 'service-line-epilepsy', label: 'Epilepsy Center' }
    ],
    'mob-dermatology': [
      { id: 'service-line-psoriasis', label: 'Psoriasis Clinic' },
      { id: 'service-line-mohs', label: 'Mohs Surgery' }
    ],
    'mob-pulmonology': [
      { id: 'service-line-asthma', label: 'Asthma Program' },
      { id: 'service-line-sleep', label: 'Sleep Medicine' }
    ]
  }
};

export const mockAccessMetrics = {
  'region-primary-care': {
    tnaDays: 12,
    tnaTarget: 7,
    backlogCount: 450,
    sameDayRate: 0.35,
    templateUtilization: 0.82,
    noShowRate: 0.08,
    cancelRate: 0.12,
    trend6Month: [
      { month: 'Sep', tna: 10, backlog: 420, sameDay: 0.38 },
      { month: 'Oct', tna: 11, backlog: 430, sameDay: 0.36 },
      { month: 'Nov', tna: 12, backlog: 450, sameDay: 0.35 },
      { month: 'Dec', tna: 12, backlog: 455, sameDay: 0.34 },
      { month: 'Jan', tna: 11, backlog: 440, sameDay: 0.36 },
      { month: 'Feb', tna: 12, backlog: 450, sameDay: 0.35 }
    ]
  },
  'region-specialty-care': {
    tnaDays: 9,
    tnaTarget: 6,
    backlogCount: 320,
    sameDayRate: 0.28,
    templateUtilization: 0.88,
    noShowRate: 0.06,
    cancelRate: 0.09,
    trend6Month: [
      { month: 'Sep', tna: 8, backlog: 300, sameDay: 0.30 },
      { month: 'Oct', tna: 9, backlog: 310, sameDay: 0.29 },
      { month: 'Nov', tna: 9, backlog: 320, sameDay: 0.28 },
      { month: 'Dec', tna: 10, backlog: 330, sameDay: 0.27 },
      { month: 'Jan', tna: 9, backlog: 320, sameDay: 0.28 },
      { month: 'Feb', tna: 9, backlog: 320, sameDay: 0.28 }
    ]
  }
};

export const mockQualityMetrics = {
  'region-primary-care': {
    diabetesControl: 0.78,
    diabetesTarget: 0.85,
    hypertensionControl: 0.82,
    hypertensionTarget: 0.80,
    cancerScreeningRate: 0.65,
    cancerScreeningTarget: 0.75,
    careGapClosureRate: 0.42,
    trendMoM: [
      { month: 'Sep', diabetes: 0.76, hypertension: 0.80, screening: 0.62 },
      { month: 'Oct', diabetes: 0.77, hypertension: 0.81, screening: 0.64 },
      { month: 'Nov', diabetes: 0.78, hypertension: 0.82, screening: 0.65 },
      { month: 'Dec', diabetes: 0.78, hypertension: 0.81, screening: 0.66 },
      { month: 'Jan', diabetes: 0.79, hypertension: 0.82, screening: 0.66 },
      { month: 'Feb', diabetes: 0.78, hypertension: 0.82, screening: 0.65 }
    ]
  },
  'region-specialty-care': {
    diabetesControl: 0.81,
    diabetesTarget: 0.85,
    hypertensionControl: 0.79,
    hypertensionTarget: 0.80,
    cancerScreeningRate: 0.70,
    cancerScreeningTarget: 0.75,
    careGapClosureRate: 0.48,
    trendMoM: [
      { month: 'Sep', diabetes: 0.80, hypertension: 0.78, screening: 0.68 },
      { month: 'Oct', diabetes: 0.80, hypertension: 0.79, screening: 0.69 },
      { month: 'Nov', diabetes: 0.81, hypertension: 0.79, screening: 0.70 },
      { month: 'Dec', diabetes: 0.82, hypertension: 0.80, screening: 0.71 },
      { month: 'Jan', diabetes: 0.81, hypertension: 0.80, screening: 0.70 },
      { month: 'Feb', diabetes: 0.81, hypertension: 0.79, screening: 0.70 }
    ]
  }
};

export const mockStaffingMetrics = {
  'region-primary-care': {
    vacancyRate: 0.12,
    vacancyTarget: 0.05,
    overtimeRate: 0.18,
    overtimeTarget: 0.10,
    deploymentSuccessRate: 0.85,
    skillMixMatch: 0.90,
    upcomingGaps: 8,
    trend6Month: [
      { month: 'Sep', vacancy: 0.10, overtime: 0.15, deployment: 0.87 },
      { month: 'Oct', vacancy: 0.11, overtime: 0.16, deployment: 0.86 },
      { month: 'Nov', vacancy: 0.12, overtime: 0.18, deployment: 0.85 },
      { month: 'Dec', vacancy: 0.12, overtime: 0.17, deployment: 0.86 },
      { month: 'Jan', vacancy: 0.11, overtime: 0.16, deployment: 0.87 },
      { month: 'Feb', vacancy: 0.12, overtime: 0.18, deployment: 0.85 }
    ]
  },
  'region-specialty-care': {
    vacancyRate: 0.09,
    vacancyTarget: 0.05,
    overtimeRate: 0.14,
    overtimeTarget: 0.10,
    deploymentSuccessRate: 0.88,
    skillMixMatch: 0.92,
    upcomingGaps: 5,
    trend6Month: [
      { month: 'Sep', vacancy: 0.08, overtime: 0.12, deployment: 0.90 },
      { month: 'Oct', vacancy: 0.09, overtime: 0.13, deployment: 0.89 },
      { month: 'Nov', vacancy: 0.09, overtime: 0.14, deployment: 0.88 },
      { month: 'Dec', vacancy: 0.10, overtime: 0.14, deployment: 0.88 },
      { month: 'Jan', vacancy: 0.09, overtime: 0.13, deployment: 0.89 },
      { month: 'Feb', vacancy: 0.09, overtime: 0.14, deployment: 0.88 }
    ]
  }
};

export const mockFinanceMetrics = {
  'region-primary-care': {
    laborCost: 2400000,
    laborBudget: 2300000,
    variancePct: 0.043,
    overtimeSpend: 180000,
    overtimePctOfLabor: 0.075,
    trend12Month: [
      { month: 'Dec', labor: 2350000, budget: 2300000, overtime: 175000 },
      { month: 'Jan', labor: 2400000, budget: 2300000, overtime: 180000 },
      { month: 'Feb', labor: 2380000, budget: 2300000, overtime: 178000 },
      { month: 'Mar', labor: 2360000, budget: 2300000, overtime: 176000 },
      { month: 'Apr', labor: 2390000, budget: 2300000, overtime: 179000 },
      { month: 'May', labor: 2400000, budget: 2300000, overtime: 180000 }
    ]
  },
  'region-specialty-care': {
    laborCost: 1950000,
    laborBudget: 1900000,
    variancePct: 0.026,
    overtimeSpend: 125000,
    overtimePctOfLabor: 0.064,
    trend12Month: [
      { month: 'Dec', labor: 1920000, budget: 1900000, overtime: 120000 },
      { month: 'Jan', labor: 1950000, budget: 1900000, overtime: 125000 },
      { month: 'Feb', labor: 1940000, budget: 1900000, overtime: 123000 },
      { month: 'Mar', labor: 1930000, budget: 1900000, overtime: 122000 },
      { month: 'Apr', labor: 1940000, budget: 1900000, overtime: 124000 },
      { month: 'May', labor: 1950000, budget: 1900000, overtime: 125000 }
    ]
  }
};

export const mockInitiativesMonitoring = {
  'region-primary-care': [
    {
      id: 'init-001',
      name: 'Reduce ED Wait Times',
      status: 'at-risk',
      nextMilestone: 'Complete staffing analysis',
      milestoneDueDate: '2026-03-15',
      owner: 'Sarah Chen',
      progress: 0.65
    },
    {
      id: 'init-002',
      name: 'Flu Vaccination Push',
      status: 'on-track',
      nextMilestone: 'Achieve 90% staff vaccination',
      milestoneDueDate: '2026-02-28',
      owner: 'Jennifer Martinez',
      progress: 0.88
    }
  ],
  'region-specialty-care': [
    {
      id: 'init-003',
      name: 'Reduce MRI Backlog',
      status: 'off-track',
      nextMilestone: 'Add weekend sessions',
      milestoneDueDate: '2026-03-10',
      owner: 'Michael Brown',
      progress: 0.42
    }
  ]
};

export const mockInitiativesTrend = {
  'region-primary-care': [
    { month: 'Sep', pctOnTrack: 0.75, milestonesHit: 0.80 },
    { month: 'Oct', pctOnTrack: 0.70, milestonesHit: 0.78 },
    { month: 'Nov', pctOnTrack: 0.72, milestonesHit: 0.82 },
    { month: 'Dec', pctOnTrack: 0.74, milestonesHit: 0.84 },
    { month: 'Jan', pctOnTrack: 0.76, milestonesHit: 0.86 },
    { month: 'Feb', pctOnTrack: 0.78, milestonesHit: 0.88 }
  ],
  'region-specialty-care': [
    { month: 'Sep', pctOnTrack: 0.68, milestonesHit: 0.74 },
    { month: 'Oct', pctOnTrack: 0.66, milestonesHit: 0.72 },
    { month: 'Nov', pctOnTrack: 0.67, milestonesHit: 0.73 },
    { month: 'Dec', pctOnTrack: 0.69, milestonesHit: 0.75 },
    { month: 'Jan', pctOnTrack: 0.70, milestonesHit: 0.76 },
    { month: 'Feb', pctOnTrack: 0.71, milestonesHit: 0.77 }
  ]
};

// Hierarchical performance buckets for pillar tabs (Region→MOB, MOB→Service Line, Service Line→Unit)
export const mockPerformanceBucketsByScope = {
  'region-primary-care': [
    { id: 'mob-cardiology', name: 'Cardiology', score: 78, target: 75, trend: 3, status: 'on-track', accentColor: 'green' },
    { id: 'mob-orthopedics', name: 'Orthopedics', score: 72, target: 75, trend: -5, status: 'below-target', accentColor: 'yellow' },
    { id: 'mob-oncology', name: 'Oncology', score: 82, target: 75, trend: 4, status: 'on-track', accentColor: 'green' }
  ],
  'region-specialty-care': [
    { id: 'mob-neurology', name: 'Neurology', score: 75, target: 75, trend: 0, status: 'on-track', accentColor: 'green' },
    { id: 'mob-dermatology', name: 'Dermatology', score: 80, target: 75, trend: 2, status: 'on-track', accentColor: 'green' },
    { id: 'mob-pulmonology', name: 'Pulmonology', score: 68, target: 75, trend: -8, status: 'critical', accentColor: 'red' }
  ],
  'mob-cardiology': [
    { id: 'service-line-interventional-cardiology', name: 'Interventional Cardiology', score: 76, target: 75, trend: 2, status: 'on-track', accentColor: 'green' },
    { id: 'service-line-electrophysiology', name: 'Electrophysiology', score: 81, target: 75, trend: 5, status: 'on-track', accentColor: 'green' }
  ],
  'mob-orthopedics': [
    { id: 'service-line-joint-replacement', name: 'Joint Replacement', score: 74, target: 75, trend: -3, status: 'below-target', accentColor: 'yellow' },
    { id: 'service-line-sports-medicine', name: 'Sports Medicine', score: 79, target: 75, trend: 4, status: 'on-track', accentColor: 'green' }
  ],
  'mob-oncology': [
    { id: 'service-line-radiation-oncology', name: 'Radiation Oncology', score: 85, target: 75, trend: 6, status: 'on-track', accentColor: 'green' },
    { id: 'service-line-medical-oncology', name: 'Medical Oncology', score: 79, target: 75, trend: 3, status: 'on-track', accentColor: 'green' }
  ],
  'mob-neurology': [
    { id: 'service-line-stroke', name: 'Stroke Care', score: 77, target: 75, trend: 2, status: 'on-track', accentColor: 'green' },
    { id: 'service-line-epilepsy', name: 'Epilepsy Center', score: 73, target: 75, trend: -4, status: 'below-target', accentColor: 'yellow' }
  ],
  'mob-dermatology': [
    { id: 'service-line-psoriasis', name: 'Psoriasis Clinic', score: 82, target: 75, trend: 4, status: 'on-track', accentColor: 'green' },
    { id: 'service-line-mohs', name: 'Mohs Surgery', score: 78, target: 75, trend: 1, status: 'on-track', accentColor: 'green' }
  ],
  'mob-pulmonology': [
    { id: 'service-line-asthma', name: 'Asthma Program', score: 70, target: 75, trend: -6, status: 'critical', accentColor: 'red' },
    { id: 'service-line-sleep', name: 'Sleep Medicine', score: 66, target: 75, trend: -9, status: 'critical', accentColor: 'red' }
  ],
  'service-line-interventional-cardiology': [
    { id: 'unit-main', name: 'Main Hospital Cath Lab', score: 78, target: 75, trend: 3, status: 'on-track', accentColor: 'green' },
    { id: 'unit-west', name: 'West Campus Cath Lab', score: 74, target: 75, trend: -2, status: 'below-target', accentColor: 'yellow' }
  ],
  'service-line-electrophysiology': [
    { id: 'unit-eps-1', name: 'EP Lab 1', score: 84, target: 75, trend: 6, status: 'on-track', accentColor: 'green' },
    { id: 'unit-eps-2', name: 'EP Lab 2', score: 79, target: 75, trend: 2, status: 'on-track', accentColor: 'green' }
  ],
  'service-line-joint-replacement': [
    { id: 'unit-jr-1', name: 'Joint Replacement Unit A', score: 76, target: 75, trend: 1, status: 'on-track', accentColor: 'green' },
    { id: 'unit-jr-2', name: 'Joint Replacement Unit B', score: 72, target: 75, trend: -5, status: 'below-target', accentColor: 'yellow' }
  ],
  'service-line-sports-medicine': [
    { id: 'unit-sm-1', name: 'Sports Medicine Clinic', score: 82, target: 75, trend: 4, status: 'on-track', accentColor: 'green' }
  ],
  'service-line-radiation-oncology': [
    { id: 'unit-ro-1', name: 'Radiation Oncology Unit', score: 88, target: 75, trend: 7, status: 'on-track', accentColor: 'green' }
  ],
  'service-line-medical-oncology': [
    { id: 'unit-mo-1', name: 'Medical Oncology Unit', score: 82, target: 75, trend: 3, status: 'on-track', accentColor: 'green' }
  ],
  'service-line-stroke': [
    { id: 'unit-stroke-1', name: 'Stroke Unit', score: 79, target: 75, trend: 2, status: 'on-track', accentColor: 'green' }
  ],
  'service-line-epilepsy': [
    { id: 'unit-ep-1', name: 'Epilepsy Center', score: 75, target: 75, trend: 0, status: 'on-track', accentColor: 'green' }
  ],
  'service-line-psoriasis': [
    { id: 'unit-ps-1', name: 'Psoriasis Clinic', score: 84, target: 75, trend: 5, status: 'on-track', accentColor: 'green' }
  ],
  'service-line-mohs': [
    { id: 'unit-mohs-1', name: 'Mohs Surgery Unit', score: 78, target: 75, trend: 2, status: 'on-track', accentColor: 'green' }
  ],
  'service-line-asthma': [
    { id: 'unit-ast-1', name: 'Asthma Program', score: 71, target: 75, trend: -5, status: 'below-target', accentColor: 'yellow' }
  ],
  'service-line-sleep': [
    { id: 'unit-sleep-1', name: 'Sleep Lab', score: 67, target: 75, trend: -8, status: 'critical', accentColor: 'red' }
  ]
};

// mockConsumerInsights replaced by mockDirectorConsumerKPIs + mockDirectorFacilityComparison below

// ==========================================
// PRACTICE OPERATIONS — OpsRibbon mock data
// ==========================================
export const mockTaskSummary = {
  completed: 12,
  total: 18,
  overdue: 3,
  overdueBreakdown: [
    { label: '2 due this AM', priority: 'high' },
    { label: '1 from yesterday', priority: 'critical' },
  ],
};

export const mockChecklistStatus = {
  dueToday: 2,
  dueThisWeek: 4,
  onTrack: 6,
  overdue: 1,
  atRisk: 1,
  total: 8,
};

export const mockDomainTaskHealth = [
  { domain: 'staffing',  label: 'Staffing',             status: 'live',  overdueCount: 0 },
  { domain: 'access',    label: 'Scheduling & Access',   status: 'stale', overdueCount: 1 },
  { domain: 'health',    label: 'Population Health',     status: 'live',  overdueCount: 0 },
  { domain: 'quality',   label: 'Quality & Regulatory',  status: 'error', overdueCount: 2 },
  { domain: 'finance',   label: 'Financial Tracking',    status: 'stale', overdueCount: 1 },
  { domain: 'consumer',  label: 'Consumer Insights',     status: 'live',  overdueCount: 0 },
  { domain: 'practice',  label: 'Practice Management',   status: 'error', overdueCount: 3 },
  { domain: 'ops',       label: 'Ops Reliability',       status: 'live',  overdueCount: 0 },
];

// ==========================================
// RELIABILITY BAR — sparkline trend + stats
// ==========================================
export const mockReliabilityTrend = [
  { day: 'Mon', score: 82 },
  { day: 'Tue', score: 84 },
  { day: 'Wed', score: 81 },
  { day: 'Thu', score: 86 },
  { day: 'Fri', score: 85 },
  { day: 'Sat', score: 88 },
  { day: 'Sun', score: 87 },
];

export const mockReliabilityStats = {
  score: 87,
  avgInterventionHrs: 2.4,
  interventionDelta: -0.3,
  resolutionRate: 91,
  backlogVariability: 8.2,
  backlogTarget: 10,
  activeThreads: 14,
  criticalThreads: 3,
};

// ==========================================
// CONSUMER INSIGHTS — Overview tab (FCI.5)  [unit-keyed]
// ==========================================
const _overviewBase = {
  'unit-main-st': {
    cpfiScore: { value: 78, target: 80, trend: 2.1 },
    googleRating: { value: 4.5, totalReviews: 524, trend30d: 0.1 },
    cahpsComposite: { value: 85, nationalAvg: 78, trendQoQ: 3.0 },
    openComplaints: { total: 2, aging: { under3d: 1, d3to7: 1, over7d: 0 } },
  },
  'unit-oak-park': {
    cpfiScore: { value: 70, target: 80, trend: -1.5 },
    googleRating: { value: 4.1, totalReviews: 412, trend30d: -0.1 },
    cahpsComposite: { value: 79, nationalAvg: 78, trendQoQ: 0.5 },
    openComplaints: { total: 3, aging: { under3d: 1, d3to7: 0, over7d: 2 } },
  },
  'unit-riverside': {
    cpfiScore: { value: 72, target: 80, trend: 1.0 },
    googleRating: { value: 4.2, totalReviews: 311, trend30d: 0.2 },
    cahpsComposite: { value: 81, nationalAvg: 78, trendQoQ: 1.8 },
    openComplaints: { total: 2, aging: { under3d: 1, d3to7: 1, over7d: 0 } },
  },
};
export const mockConsumerOverview = {
  ..._overviewBase,
  all: {
    cpfiScore: { value: 74, target: 80, trend: 1.0 },
    googleRating: { value: 4.3, totalReviews: 1247, trend30d: 0.1 },
    cahpsComposite: { value: 82, nationalAvg: 78, trendQoQ: 2.1 },
    openComplaints: { total: 7, aging: { under3d: 3, d3to7: 2, over7d: 2 } },
  },
};

// ==========================================
// CONSUMER INSIGHTS — Surveys / CAHPS tab (FCI.1)  [unit-keyed]
// ==========================================
const _surveysBase = {
  'unit-main-st': {
    domains: [
      { key: 'communication',     label: 'Communication',     score: 87, benchmark: 80, mipsThreshold: 75, trend: 3.1 },
      { key: 'care_coordination', label: 'Care Coordination', score: 74, benchmark: 78, mipsThreshold: 70, trend: -0.5 },
      { key: 'access',            label: 'Access',            score: 80, benchmark: 82, mipsThreshold: 72, trend: 1.2 },
      { key: 'office_staff',      label: 'Office Staff',      score: 91, benchmark: 80, mipsThreshold: 75, trend: 4.0 },
    ],
    uploadHistory: [
      { id: 'up-001', date: '2026-03-15', vendor: 'Press Ganey', period: 'Q1 2026', status: 'parsed', rowCount: 142, unitId: 'unit-main-st', unitName: 'Main St Clinic' },
    ],
  },
  'unit-oak-park': {
    domains: [
      { key: 'communication',     label: 'Communication',     score: 80, benchmark: 80, mipsThreshold: 75, trend: 1.0 },
      { key: 'care_coordination', label: 'Care Coordination', score: 68, benchmark: 78, mipsThreshold: 70, trend: -2.1 },
      { key: 'access',            label: 'Access',            score: 72, benchmark: 82, mipsThreshold: 72, trend: -0.3 },
      { key: 'office_staff',      label: 'Office Staff',      score: 84, benchmark: 80, mipsThreshold: 75, trend: 2.0 },
    ],
    uploadHistory: [
      { id: 'up-002', date: '2026-01-10', vendor: 'SurveyVitals', period: 'Q4 2025', status: 'parsed', rowCount: 98, unitId: 'unit-oak-park', unitName: 'Oak Park Family' },
    ],
  },
  'unit-riverside': {
    domains: [
      { key: 'communication',     label: 'Communication',     score: 84, benchmark: 80, mipsThreshold: 75, trend: 2.1 },
      { key: 'care_coordination', label: 'Care Coordination', score: 71, benchmark: 78, mipsThreshold: 70, trend: -1.3 },
      { key: 'access',            label: 'Access',            score: 76, benchmark: 82, mipsThreshold: 72, trend: 0.5 },
      { key: 'office_staff',      label: 'Office Staff',      score: 88, benchmark: 80, mipsThreshold: 75, trend: 3.0 },
    ],
    uploadHistory: [
      { id: 'up-003', date: '2025-10-05', vendor: 'PRC', period: 'Q3 2025', status: 'error', rowCount: 0, unitId: 'unit-riverside', unitName: 'Riverside Urgent' },
    ],
  },
};
export const mockConsumerSurveys = {
  ..._surveysBase,
  all: {
    domains: [
      { key: 'communication',     label: 'Communication',     score: 84, benchmark: 80, mipsThreshold: 75, trend: 2.1 },
      { key: 'care_coordination', label: 'Care Coordination', score: 71, benchmark: 78, mipsThreshold: 70, trend: -1.3 },
      { key: 'access',            label: 'Access',            score: 76, benchmark: 82, mipsThreshold: 72, trend: 0.5 },
      { key: 'office_staff',      label: 'Office Staff',      score: 88, benchmark: 80, mipsThreshold: 75, trend: 3.0 },
    ],
    uploadHistory: [
      ..._surveysBase['unit-main-st'].uploadHistory,
      ..._surveysBase['unit-oak-park'].uploadHistory,
      ..._surveysBase['unit-riverside'].uploadHistory,
    ],
  },
};

// ==========================================
// CONSUMER INSIGHTS — Online Reputation tab (FCI.2)  [unit-keyed]
// ==========================================
const _reputationBase = {
  'unit-main-st': {
    avgRating: 4.5, totalReviews: 524,
    trend: [{ period: '90d', value: 4.3 }, { period: '60d', value: 4.4 }, { period: '30d', value: 4.5 }],
    volume30d: 18, volumePrior30: 15,
    lastSync: '2026-03-29T06:00:00Z', gmbDeepLink: 'https://business.google.com/reviews/main-st',
    reviews: [
      { id: 'rev-101', stars: 5, date: '2026-03-27', text: 'Wonderful experience with Dr. Chen.', responded: true, daysUnanswered: 0, unitId: 'unit-main-st', unitName: 'Main St Clinic' },
      { id: 'rev-102', stars: 4, date: '2026-03-23', text: 'Good care overall, but parking is terrible.', responded: true, daysUnanswered: 0, unitId: 'unit-main-st', unitName: 'Main St Clinic' },
      { id: 'rev-103', stars: 5, date: '2026-03-18', text: 'Dr. Chen is amazing! Always takes time to listen.', responded: true, daysUnanswered: 0, unitId: 'unit-main-st', unitName: 'Main St Clinic' },
    ],
  },
  'unit-oak-park': {
    avgRating: 4.1, totalReviews: 412,
    trend: [{ period: '90d', value: 4.2 }, { period: '60d', value: 4.1 }, { period: '30d', value: 4.1 }],
    volume30d: 14, volumePrior30: 12,
    lastSync: '2026-03-29T06:00:00Z', gmbDeepLink: 'https://business.google.com/reviews/oak-park',
    reviews: [
      { id: 'rev-201', stars: 2, date: '2026-03-25', text: 'Waited over an hour past my appointment time.', responded: false, daysUnanswered: 5, unitId: 'unit-oak-park', unitName: 'Oak Park Family' },
      { id: 'rev-202', stars: 1, date: '2026-03-20', text: 'Billing nightmare. Charged twice for same procedure.', responded: false, daysUnanswered: 10, unitId: 'unit-oak-park', unitName: 'Oak Park Family' },
    ],
  },
  'unit-riverside': {
    avgRating: 4.2, totalReviews: 311,
    trend: [{ period: '90d', value: 4.0 }, { period: '60d', value: 4.1 }, { period: '30d', value: 4.2 }],
    volume30d: 10, volumePrior30: 8,
    lastSync: '2026-03-29T06:00:00Z', gmbDeepLink: 'https://business.google.com/reviews/riverside',
    reviews: [
      { id: 'rev-301', stars: 3, date: '2026-03-26', text: 'Decent urgent care visit. Could improve wait time.', responded: true, daysUnanswered: 0, unitId: 'unit-riverside', unitName: 'Riverside Urgent' },
      { id: 'rev-302', stars: 5, date: '2026-03-22', text: 'Fast and professional. Highly recommend.', responded: true, daysUnanswered: 0, unitId: 'unit-riverside', unitName: 'Riverside Urgent' },
    ],
  },
};
export const mockConsumerReputation = {
  ..._reputationBase,
  all: {
    avgRating: 4.3, totalReviews: 1247,
    trend: [{ period: '90d', value: 4.1 }, { period: '60d', value: 4.2 }, { period: '30d', value: 4.3 }],
    volume30d: 42, volumePrior30: 35,
    lastSync: '2026-03-29T06:00:00Z', gmbDeepLink: 'https://business.google.com/reviews',
    reviews: [
      ..._reputationBase['unit-main-st'].reviews.slice(0, 2),
      ..._reputationBase['unit-oak-park'].reviews,
      ..._reputationBase['unit-riverside'].reviews.slice(0, 1),
    ].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 5),
  },
};

// ==========================================
// CONSUMER INSIGHTS — Complaints Tracker tab (FCI.3)  [unit-keyed]
// ==========================================
const _complaintsMainSt = [
  { id: 'cmp-001', source: 'Patient Portal', category: 'patient_complaint', urgency: 3, daysOpen: 2, owner: 'Sarah Chen', status: 'open', subject: 'Long wait time - patient waited 45 min', isLegal: false, estimatedCost: 500, unitId: 'unit-main-st', unitName: 'Main St Clinic', notes: [], createdAt: '2026-03-28' },
  { id: 'cmp-003', source: 'Attorney Letter', category: 'legal_escalation', urgency: 5, daysOpen: 1, owner: null, status: 'open', subject: 'Slip and fall - demand letter from patient attorney', isLegal: true, estimatedCost: 25000, unitId: 'unit-main-st', unitName: 'Main St Clinic', notes: [], createdAt: '2026-03-29' },
];
const _complaintsOakPark = [
  { id: 'cmp-002', source: 'Phone Call', category: 'formal_grievance', urgency: 4, daysOpen: 5, owner: 'David Park', status: 'in_progress', subject: 'Billing dispute - incorrect charge on EOB', isLegal: false, estimatedCost: 1200, unitId: 'unit-oak-park', unitName: 'Oak Park Family', notes: ['Contacted billing dept 3/25'], createdAt: '2026-03-25' },
  { id: 'cmp-004', source: 'Google Review', category: 'patient_complaint', urgency: 2, daysOpen: 8, owner: 'Jennifer Liu', status: 'open', subject: 'Rude front desk interaction - patient left without being seen', isLegal: false, estimatedCost: 300, unitId: 'unit-oak-park', unitName: 'Oak Park Family', notes: [], createdAt: '2026-03-22' },
  { id: 'cmp-006', source: 'Email Signal', category: 'formal_grievance', urgency: 3, daysOpen: 6, owner: 'David Park', status: 'in_progress', subject: 'Medical records request delay - over 30 day wait', isLegal: false, estimatedCost: 800, unitId: 'unit-oak-park', unitName: 'Oak Park Family', notes: ['Escalated to HIM dept 3/24'], createdAt: '2026-03-24' },
];
const _complaintsRiverside = [
  { id: 'cmp-005', source: 'Patient Portal', category: 'patient_complaint', urgency: 2, daysOpen: 3, owner: 'Sarah Chen', status: 'resolved', subject: 'Appointment cancellation without notice', isLegal: false, estimatedCost: 200, unitId: 'unit-riverside', unitName: 'Riverside Urgent', notes: ['Resolved with rescheduled appt and apology call'], createdAt: '2026-03-27' },
  { id: 'cmp-007', source: 'Phone Call', category: 'patient_complaint', urgency: 1, daysOpen: 1, owner: 'Jennifer Liu', status: 'open', subject: 'Parking lot accessibility concern', isLegal: false, estimatedCost: 100, unitId: 'unit-riverside', unitName: 'Riverside Urgent', notes: [], createdAt: '2026-03-29' },
];
export const mockConsumerComplaints = {
  'unit-main-st': _complaintsMainSt,
  'unit-oak-park': _complaintsOakPark,
  'unit-riverside': _complaintsRiverside,
  all: [..._complaintsMainSt, ..._complaintsOakPark, ..._complaintsRiverside].sort((a, b) => b.urgency - a.urgency),
};

// ==========================================
// CONSUMER INSIGHTS — Signal Feed tab (FCI.4)  [unit-keyed]
// Signal shape matches <SignalCard> expectations: { id, priority, source, title, description, flagged }
// plus consumer-specific fields: urgency, classification, confidence, entities, sender, receivedAt
// ==========================================
const URGENCY_TO_PRIORITY = { 5: 'critical', 4: 'high', 3: 'medium', 2: 'low', 1: 'low' };
function _sig(id, urgency, classification, title, sender, confidence, entities, receivedAt, unitId, unitName, dismissed) {
  return {
    id, urgency, classification, confidence, sender, entities, receivedAt, unitId, unitName, dismissed,
    isLegal: urgency === 5,
    // SignalCard-compatible fields
    priority: URGENCY_TO_PRIORITY[urgency] || 'low',
    source: 'consumer',
    title,
    description: `From: ${sender} · Confidence: ${(confidence * 100).toFixed(0)}%`,
    flagged: urgency === 5,
  };
}
const _signalsMainSt = [
  _sig('csig-001', 5, 'legal_escalation', 'Demand letter - patient fall incident', 'attorney@lawfirm.com', 0.97, { patient: 'John Doe', date: '2026-03-15', location: 'Main lobby' }, '2026-03-28T09:05:00Z', 'unit-main-st', 'Main St Clinic', false),
  _sig('csig-003', 3, 'review_alert', 'New 1-star review for Main St Clinic', 'noreply@google.com', 0.88, { rating: '1 star', topic: 'wait time' }, '2026-03-27T16:40:00Z', 'unit-main-st', 'Main St Clinic', false),
];
const _signalsOakPark = [
  _sig('csig-002', 4, 'billing_dispute', 'Billing overcharge complaint - MRI procedure', 'patient_feedback@gmail.com', 0.91, { amount: '$1,240', service: 'MRI', date: '2026-03-10' }, '2026-03-28T14:22:00Z', 'unit-oak-park', 'Oak Park Family', false),
  _sig('csig-005', 3, 'patient_complaint', 'Follow-up complaint about staff behavior', 'patient.jane@email.com', 0.84, { patient: 'Jane Smith', dept: 'Front desk', date: '2026-03-22' }, '2026-03-26T11:30:00Z', 'unit-oak-park', 'Oak Park Family', false),
  _sig('csig-007', 5, 'legal_escalation', 'Formal grievance filing acknowledgment', 'legal@statehealth.gov', 0.99, { caseId: 'GRV-2026-0412', agency: 'State Health Dept' }, '2026-03-24T15:20:00Z', 'unit-oak-park', 'Oak Park Family', false),
];
const _signalsRiverside = [
  _sig('csig-004', 2, 'cahps_notification', 'CAHPS Q1 results ready for upload', 'compliance@hospital.org', 0.95, { vendor: 'Press Ganey', period: 'Q1 2026' }, '2026-03-27T10:15:00Z', 'unit-riverside', 'Riverside Urgent', false),
  _sig('csig-006', 3, 'review_alert', 'New 2-star review - billing issues mentioned', 'noreply@google.com', 0.86, { rating: '2 stars', topic: 'billing' }, '2026-03-25T08:45:00Z', 'unit-riverside', 'Riverside Urgent', false),
];
export const mockConsumerSignals = {
  'unit-main-st': _signalsMainSt,
  'unit-oak-park': _signalsOakPark,
  'unit-riverside': _signalsRiverside,
  all: [..._signalsMainSt, ..._signalsOakPark, ..._signalsRiverside].sort((a, b) => b.urgency - a.urgency || b.receivedAt.localeCompare(a.receivedAt)),
};

// ==========================================
// DIRECTOR — Consumer KPIs (scoped)
// ==========================================
export const mockDirectorConsumerKPIs = {
  cpfiQuality: { value: 72, target: 80, trend: -1.2 },
  complaintCount: 34,
  complaintRate: 2.8,
  escalationRate: 0.12,
  googleRatingAvg: 4.2,
  resolutionRate: 0.78,
};

// ==========================================
// DIRECTOR — Facility Comparison Table
// ==========================================
export const mockDirectorFacilityComparison = [
  { unitId: 'unit-main-st',    name: 'Main St Clinic',     mob: 'Eastside MOB',  googleRating: 4.5, cahpsComposite: 85, openComplaints: 2,  complaintsOver7d: 0, legalEscalations: 1, resolutionRate: 0.92, signalVolume30d: 8,  atRisk: false },
  { unitId: 'unit-oak-park',   name: 'Oak Park Family',    mob: 'Eastside MOB',  googleRating: 4.1, cahpsComposite: 79, openComplaints: 3,  complaintsOver7d: 2, legalEscalations: 1, resolutionRate: 0.71, signalVolume30d: 12, atRisk: false },
  { unitId: 'unit-riverside',  name: 'Riverside Urgent',   mob: 'Westside MOB',  googleRating: 4.2, cahpsComposite: 81, openComplaints: 2,  complaintsOver7d: 0, legalEscalations: 0, resolutionRate: 0.85, signalVolume30d: 6,  atRisk: false },
  { unitId: 'unit-cedar-hill', name: 'Cedar Hill Primary',  mob: 'Westside MOB',  googleRating: 3.8, cahpsComposite: 74, openComplaints: 5,  complaintsOver7d: 3, legalEscalations: 0, resolutionRate: 0.65, signalVolume30d: 15, atRisk: false },
  { unitId: 'unit-lakewood',   name: 'Lakewood Family',    mob: 'Southside MOB', googleRating: 4.4, cahpsComposite: 83, openComplaints: 1,  complaintsOver7d: 0, legalEscalations: 0, resolutionRate: 0.94, signalVolume30d: 4,  atRisk: false },
  { unitId: 'unit-downtown',   name: 'Downtown Clinic',    mob: 'Southside MOB', googleRating: 3.4, cahpsComposite: 70, openComplaints: 11, complaintsOver7d: 4, legalEscalations: 2, resolutionRate: 0.58, signalVolume30d: 22, atRisk: true },
  { unitId: 'unit-hillcrest',  name: 'Hillcrest Medical',  mob: 'Northside MOB', googleRating: 4.3, cahpsComposite: 82, openComplaints: 2,  complaintsOver7d: 1, legalEscalations: 0, resolutionRate: 0.88, signalVolume30d: 7,  atRisk: false },
  { unitId: 'unit-bayview',    name: 'Bayview Health',     mob: 'Northside MOB', googleRating: 4.0, cahpsComposite: 77, openComplaints: 4,  complaintsOver7d: 2, legalEscalations: 1, resolutionRate: 0.72, signalVolume30d: 10, atRisk: false },
  { unitId: 'unit-parkside',   name: 'Parkside Wellness',  mob: 'Eastside MOB',  googleRating: 4.6, cahpsComposite: 88, openComplaints: 0,  complaintsOver7d: 0, legalEscalations: 0, resolutionRate: 0.97, signalVolume30d: 3,  atRisk: false },
  { unitId: 'unit-valley',     name: 'Valley Pediatrics',  mob: 'Westside MOB',  googleRating: 4.7, cahpsComposite: 90, openComplaints: 1,  complaintsOver7d: 0, legalEscalations: 0, resolutionRate: 0.96, signalVolume30d: 5,  atRisk: false },
  { unitId: 'unit-summit',     name: 'Summit Internal Med', mob: 'Southside MOB', googleRating: 3.2, cahpsComposite: 68, openComplaints: 8,  complaintsOver7d: 3, legalEscalations: 1, resolutionRate: 0.55, signalVolume30d: 18, atRisk: true },
  { unitId: 'unit-harbor',     name: 'Harbor Point Clinic', mob: 'Northside MOB', googleRating: 4.1, cahpsComposite: 80, openComplaints: 3,  complaintsOver7d: 1, legalEscalations: 0, resolutionRate: 0.82, signalVolume30d: 9,  atRisk: false },
];

// ==========================================
// DIRECTOR — Complaint Aging Heatmap
// ==========================================
export const mockDirectorComplaintAging = mockDirectorFacilityComparison.map(f => ({
  unitId: f.unitId, name: f.name,
  under3d: f.openComplaints - f.complaintsOver7d - Math.min(1, f.openComplaints - f.complaintsOver7d),
  d3to7: Math.min(1, Math.max(0, f.openComplaints - f.complaintsOver7d)),
  over7d: f.complaintsOver7d,
}));

// ==========================================
// DIRECTOR — Legal Escalation Panel
// ==========================================
export const mockDirectorLegalEscalations = [
  { id: 'le-001', subject: 'Slip and fall - demand letter from patient attorney', urgency: 5, unitId: 'unit-main-st', unitName: 'Main St Clinic', mob: 'Eastside MOB', daysOpen: 1, status: 'open', estimatedExposure: 25000 },
  { id: 'le-002', subject: 'Formal grievance filing - State Health Dept', urgency: 5, unitId: 'unit-oak-park', unitName: 'Oak Park Family', mob: 'Eastside MOB', daysOpen: 6, status: 'in_progress', estimatedExposure: 15000 },
  { id: 'le-003', subject: 'Malpractice notice - medication error', urgency: 5, unitId: 'unit-downtown', unitName: 'Downtown Clinic', mob: 'Southside MOB', daysOpen: 14, status: 'open', estimatedExposure: 75000 },
  { id: 'le-004', subject: 'ADA compliance complaint - facility access', urgency: 5, unitId: 'unit-downtown', unitName: 'Downtown Clinic', mob: 'Southside MOB', daysOpen: 3, status: 'open', estimatedExposure: 10000 },
  { id: 'le-005', subject: 'Patient data breach notification - 12 records', urgency: 5, unitId: 'unit-summit', unitName: 'Summit Internal Med', mob: 'Southside MOB', daysOpen: 2, status: 'in_progress', estimatedExposure: 50000 },
  { id: 'le-006', subject: 'Wrongful billing class action pre-litigation', urgency: 5, unitId: 'unit-bayview', unitName: 'Bayview Health', mob: 'Northside MOB', daysOpen: 10, status: 'open', estimatedExposure: 120000 },
];

// ==========================================
// DIRECTOR — Experience Trends (12-month)
// ==========================================
export const mockDirectorExperienceTrends = {
  months: ['Apr 25','May 25','Jun 25','Jul 25','Aug 25','Sep 25','Oct 25','Nov 25','Dec 25','Jan 26','Feb 26','Mar 26'],
  cpfi:          [68, 69, 70, 69, 71, 72, 71, 73, 72, 73, 72, 72],
  cahps:         [76, 77, 76, 78, 78, 79, 79, 80, 79, 80, 81, 80],
  complaintRate: [3.8, 3.6, 3.5, 3.4, 3.3, 3.2, 3.1, 3.0, 3.1, 2.9, 2.8, 2.8],
};

// ==========================================
// DIRECTOR — Top Complaint Themes
// ==========================================
export const mockDirectorComplaintThemes = [
  { theme: 'Wait Times',         count: 12, percentOfTotal: 0.35, trend: 'increasing' },
  { theme: 'Billing Disputes',   count: 8,  percentOfTotal: 0.24, trend: 'stable' },
  { theme: 'Staff Courtesy',     count: 5,  percentOfTotal: 0.15, trend: 'decreasing' },
  { theme: 'Appointment Access', count: 4,  percentOfTotal: 0.12, trend: 'stable' },
  { theme: 'Facility Cleanliness', count: 3, percentOfTotal: 0.09, trend: 'stable' },
];

// ─── Practice Management Mock Data ──────────────────────────────────────────

export const mockPMTaskTemplates = [
  // ── Quality (7) ──
  {
    id: 'task-001',
    name: 'Review Incident Events',
    domain: 'quality',
    cadence: 'daily',
    defaultTime: '07:00',
    estimatedMinutes: 15,
    completionType: 'checkbox_note',
    toolReference: 'https://epic.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: 'joint_commission',
    criticalityTier: 'A',
    description: 'Open the Events Reporting module in Epic and review all new incident events filed since the previous day. Document any safety concerns requiring follow-up or escalation.',
  },
  {
    id: 'task-002',
    name: 'HTN Dashboard Review',
    domain: 'quality',
    cadence: 'daily',
    defaultTime: '07:15',
    estimatedMinutes: 10,
    completionType: 'checkbox',
    toolReference: 'https://tableau.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Check the hypertension control dashboard in Tableau to verify panel performance against HEDIS targets and identify patients requiring outreach.',
  },
  {
    id: 'task-003',
    name: 'Flu Dashboard Review',
    domain: 'quality',
    cadence: 'weekly',
    defaultTime: '08:00',
    estimatedMinutes: 10,
    completionType: 'checkbox',
    toolReference: 'https://tableau.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'C',
    description: 'Review seasonal flu vaccination rates on the Tableau dashboard and compare against regional benchmarks to identify outreach gaps.',
  },
  {
    id: 'task-004',
    name: 'OB Dashboard Review',
    domain: 'quality',
    cadence: 'daily',
    defaultTime: '07:30',
    estimatedMinutes: 10,
    completionType: 'checkbox',
    toolReference: 'https://tableau.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Review the OB panel dashboard for prenatal visit adherence, gestational diabetes screening rates, and any patients overdue for appointments.',
  },
  {
    id: 'task-005',
    name: 'Pediatric Dashboard Review',
    domain: 'quality',
    cadence: 'daily',
    defaultTime: '07:45',
    estimatedMinutes: 10,
    completionType: 'checkbox',
    toolReference: 'https://tableau.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'C',
    description: 'Check pediatric well-child visit compliance and immunization rates on the Tableau dashboard, flagging any patients behind schedule.',
  },
  {
    id: 'task-006',
    name: 'MTHA Completion Review',
    domain: 'quality',
    cadence: 'weekly',
    defaultTime: '09:00',
    estimatedMinutes: 20,
    completionType: 'checkbox_note',
    toolReference: 'https://epic.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Audit the My Total Health Assessment completion rates in Epic and follow up with providers whose panels are below the 80% target.',
  },
  {
    id: 'task-007',
    name: 'DRS Readability Check',
    domain: 'quality',
    cadence: 'weekly',
    defaultTime: '10:00',
    estimatedMinutes: 15,
    completionType: 'checkbox_linked',
    toolReference: 'https://epic.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'C',
    description: 'Review a sample of discharge and referral summaries in Epic for readability, completeness, and appropriate patient education materials attached.',
  },
  // ── Staffing (5) ──
  {
    id: 'task-008',
    name: 'Daily Attendance Tracking',
    domain: 'staffing',
    cadence: 'daily',
    defaultTime: '06:30',
    estimatedMinutes: 20,
    completionType: 'checkbox_note',
    toolReference: 'https://staffing.nexonurse.com',
    defaultOwnerRole: 'charge_nurse',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'A',
    description: 'Log into the staffing platform at shift start to confirm all scheduled staff have arrived, document any call-outs, and initiate coverage protocols for open slots.',
  },
  {
    id: 'task-009',
    name: 'Staffing Schedule Build',
    domain: 'staffing',
    cadence: 'weekly',
    defaultTime: '14:00',
    estimatedMinutes: 45,
    completionType: 'checkbox_linked',
    toolReference: 'https://staffing.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'A',
    description: 'Build the upcoming week schedule in the staffing platform, balancing FTE allocations, PTO requests, and minimum coverage requirements across all provider teams.',
  },
  {
    id: 'task-010',
    name: 'Vacancy Spreadsheet Update',
    domain: 'staffing',
    cadence: 'weekly',
    defaultTime: '11:00',
    estimatedMinutes: 15,
    completionType: 'checkbox_note',
    toolReference: 'https://nexonurse.sharepoint.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'C',
    description: 'Update the vacancy tracking spreadsheet on SharePoint with current open positions, candidate pipeline status, and projected fill dates.',
  },
  {
    id: 'task-011',
    name: 'OT Reconciliation',
    domain: 'staffing',
    cadence: 'biweekly',
    defaultTime: '13:00',
    estimatedMinutes: 30,
    completionType: 'checkbox_linked',
    toolReference: 'https://hr.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Reconcile overtime hours against budget allocation in the HR system, flag any staff exceeding thresholds, and prepare justification memos for approved OT.',
  },
  {
    id: 'task-012',
    name: 'Cyclic Scheduling',
    domain: 'staffing',
    cadence: 'monthly',
    defaultTime: '10:00',
    estimatedMinutes: 60,
    completionType: 'checkbox_linked',
    toolReference: 'https://staffing.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Generate the next cycle schedule template incorporating standing provider preferences, clinic closures, and anticipated volume fluctuations.',
  },
  // ── Access (4) ──
  {
    id: 'task-013',
    name: 'Encounter Closure Review',
    domain: 'access',
    cadence: 'daily',
    defaultTime: '16:00',
    estimatedMinutes: 20,
    completionType: 'checkbox_note',
    toolReference: 'https://epic.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Review all open encounters from the current day in Epic, follow up with providers who have unclosed notes, and escalate any encounters open beyond 48 hours.',
  },
  {
    id: 'task-014',
    name: 'W15 Reports Review',
    domain: 'access',
    cadence: 'weekly',
    defaultTime: '09:30',
    estimatedMinutes: 15,
    completionType: 'checkbox',
    toolReference: 'https://tableau.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'C',
    description: 'Pull the Wait-15 access reports from Tableau to track appointment availability within 15 days and identify scheduling bottlenecks by provider.',
  },
  {
    id: 'task-015',
    name: 'Backsweep Reports',
    domain: 'access',
    cadence: 'weekly',
    defaultTime: '10:30',
    estimatedMinutes: 15,
    completionType: 'checkbox_note',
    toolReference: 'https://epic.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'C',
    description: 'Run the backsweep report in Epic to capture patients who left without being seen or had cancelled appointments, and initiate rebooking outreach.',
  },
  {
    id: 'task-016',
    name: '2nd BP Compliance',
    domain: 'access',
    cadence: 'weekly',
    defaultTime: '08:30',
    estimatedMinutes: 10,
    completionType: 'checkbox',
    toolReference: 'https://tableau.nexonurse.com',
    defaultOwnerRole: 'triage_rn',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Check the second blood pressure reading compliance dashboard to ensure triage nurses are capturing repeat BPs for patients with elevated initial readings.',
  },
  // ── Compliance (4) ──
  {
    id: 'task-017',
    name: 'Eyewash Station Checklist',
    domain: 'compliance',
    cadence: 'weekly',
    defaultTime: '07:00',
    estimatedMinutes: 10,
    completionType: 'checkbox',
    toolReference: null,
    defaultOwnerRole: 'charge_nurse',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: 'osha',
    criticalityTier: 'B',
    description: 'Inspect all eyewash stations for proper water flow, cleanliness, and signage per OSHA 29 CFR 1910.151 requirements and log the inspection.',
  },
  {
    id: 'task-018',
    name: 'PAPR Inspection',
    domain: 'compliance',
    cadence: 'monthly',
    defaultTime: '08:00',
    estimatedMinutes: 20,
    completionType: 'checkbox_linked',
    toolReference: null,
    defaultOwnerRole: 'charge_nurse',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: 'osha',
    criticalityTier: 'B',
    description: 'Perform monthly powered air-purifying respirator inspection including battery charge, filter condition, and seal integrity per OSHA respiratory protection standards.',
  },
  {
    id: 'task-019',
    name: 'FIT Testing Compliance',
    domain: 'compliance',
    cadence: 'monthly',
    defaultTime: '09:00',
    estimatedMinutes: 15,
    completionType: 'checkbox_note',
    toolReference: null,
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: 'osha',
    criticalityTier: 'B',
    description: 'Verify that all staff requiring N95 respirators have current fit test certifications on file and schedule appointments for anyone due for retesting.',
  },
  {
    id: 'task-020',
    name: 'LMS Compliance Check',
    domain: 'compliance',
    cadence: 'weekly',
    defaultTime: '11:00',
    estimatedMinutes: 10,
    completionType: 'checkbox',
    toolReference: null,
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: 'cms',
    criticalityTier: 'C',
    description: 'Review the learning management system to identify staff with overdue mandatory training modules and send reminder notifications.',
  },
  // ── Safety (3) ──
  {
    id: 'task-021',
    name: 'Safety Action Plan Review',
    domain: 'safety',
    cadence: 'monthly',
    defaultTime: '10:00',
    estimatedMinutes: 30,
    completionType: 'checkbox_linked',
    toolReference: 'https://nexonurse.sharepoint.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: 'joint_commission',
    criticalityTier: 'A',
    description: 'Review and update the unit safety action plan on SharePoint, ensuring all open corrective actions have assigned owners and target completion dates.',
  },
  {
    id: 'task-022',
    name: 'Medication Inspection',
    domain: 'safety',
    cadence: 'monthly',
    defaultTime: '08:00',
    estimatedMinutes: 20,
    completionType: 'checkbox_note',
    toolReference: null,
    defaultOwnerRole: 'charge_nurse',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: 'joint_commission',
    criticalityTier: 'A',
    description: 'Inspect all medication storage areas for expired drugs, proper temperature logs, and controlled substance count accuracy per Joint Commission MM standards.',
  },
  {
    id: 'task-023',
    name: 'Temperature Monitoring',
    domain: 'safety',
    cadence: 'daily',
    defaultTime: '06:45',
    estimatedMinutes: 5,
    completionType: 'checkbox',
    toolReference: null,
    defaultOwnerRole: 'triage_rn',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Check and log refrigerator and freezer temperatures for vaccine and medication storage units, reporting any out-of-range readings immediately.',
  },
  // ── Operations (4) ──
  {
    id: 'task-024',
    name: 'Huddle Board Update',
    domain: 'operations',
    cadence: 'daily',
    defaultTime: '06:45',
    estimatedMinutes: 10,
    completionType: 'checkbox',
    toolReference: 'https://nexonurse.sharepoint.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Update the digital huddle board on SharePoint with daily census, staffing status, safety alerts, and key operational messages before morning huddle.',
  },
  {
    id: 'task-025',
    name: 'Primary Care Huddle Prep',
    domain: 'operations',
    cadence: 'daily',
    defaultTime: '07:00',
    estimatedMinutes: 15,
    completionType: 'checkbox_note',
    toolReference: null,
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'A',
    description: 'Prepare the morning huddle agenda including overnight events, staffing gaps, schedule changes, and quality metric callouts for the care team.',
  },
  {
    id: 'task-026',
    name: 'Rounding',
    domain: 'operations',
    cadence: 'daily',
    defaultTime: '09:00',
    estimatedMinutes: 90,
    completionType: 'checkbox_note',
    toolReference: 'https://rounding.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'A',
    description: 'Conduct structured leadership rounding across all clinic areas using the rounding tool to capture staff concerns, patient feedback, and environmental issues.',
  },
  {
    id: 'task-027',
    name: 'Unit Meeting Prep',
    domain: 'operations',
    cadence: 'monthly',
    defaultTime: '14:00',
    estimatedMinutes: 45,
    completionType: 'checkbox_linked',
    toolReference: null,
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'C',
    description: 'Compile agenda, metrics summary, recognition items, and action item follow-ups for the monthly all-staff unit meeting.',
  },
  // ── Finance (3) ──
  {
    id: 'task-028',
    name: 'Payroll Reconciliation',
    domain: 'finance',
    cadence: 'biweekly',
    defaultTime: '08:00',
    estimatedMinutes: 120,
    completionType: 'checkbox_linked',
    toolReference: 'https://hr.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'A',
    description: 'Reconcile biweekly payroll against timeclock records in the HR system, resolve discrepancies, approve exception requests, and submit for processing.',
  },
  {
    id: 'task-029',
    name: 'Pharmacy CAM Reports',
    domain: 'finance',
    cadence: 'monthly',
    defaultTime: '10:00',
    estimatedMinutes: 30,
    completionType: 'checkbox_linked',
    toolReference: 'https://epic.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Review pharmacy cost allocation model reports from Epic to identify high-cost medication trends and opportunities for formulary optimization.',
  },
  {
    id: 'task-030',
    name: 'CRA Package Assembly',
    domain: 'finance',
    cadence: 'monthly',
    defaultTime: '13:00',
    estimatedMinutes: 45,
    completionType: 'checkbox_linked',
    toolReference: 'https://nexonurse.sharepoint.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'B',
    description: 'Assemble the cost reduction action package on SharePoint including supply utilization data, variance analysis, and proposed action items for leadership review.',
  },
  // ── Communications (3) ──
  {
    id: 'task-031',
    name: 'In-Basket Review',
    domain: 'communications',
    cadence: 'daily',
    defaultTime: '07:00',
    estimatedMinutes: 30,
    completionType: 'checkbox_note',
    toolReference: 'https://epic.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'A',
    description: 'Process all messages in the Epic In-Basket including patient messages, result notifications, referral responses, and staff communications requiring action.',
  },
  {
    id: 'task-032',
    name: 'Email Quality Review',
    domain: 'communications',
    cadence: 'weekly',
    defaultTime: '15:00',
    estimatedMinutes: 20,
    completionType: 'checkbox',
    toolReference: 'https://outlook.office365.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'C',
    description: 'Review a sample of outgoing patient communications for tone, accuracy, and compliance with organizational communication standards.',
  },
  {
    id: 'task-033',
    name: 'Outreach Performance Review',
    domain: 'communications',
    cadence: 'weekly',
    defaultTime: '14:00',
    estimatedMinutes: 15,
    completionType: 'checkbox',
    toolReference: 'https://tableau.nexonurse.com',
    defaultOwnerRole: 'com',
    isKP: false,
    active: true,
    isCustom: false,
    regulatorySource: null,
    criticalityTier: 'C',
    description: 'Review outreach campaign performance metrics in Tableau including contact rates, appointment conversion, and patient engagement scores.',
  },
];

export const mockPMTaskInstances = [
  // ── Completed (2) ──
  {
    id: 'inst-20260331-001',
    taskId: 'task-023',
    taskName: 'Temperature Monitoring',
    domain: 'safety',
    dueDate: '2026-04-13',
    dueTime: '06:45',
    status: 'completed',
    ownerRole: 'triage_rn',
    resolvedOwner: { name: 'Sarah Chen', id: 'user-sarah' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: '2026-04-13T06:50:00Z',
    completedBy: 'Sarah Chen',
    completionNote: null,
    completionType: 'checkbox',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 5,
    criticalityTier: 'B',
  },
  {
    id: 'inst-20260331-002',
    taskId: 'task-024',
    taskName: 'Huddle Board Update',
    domain: 'operations',
    dueDate: '2026-04-13',
    dueTime: '06:45',
    status: 'completed',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: '2026-04-13T06:55:00Z',
    completedBy: 'Maria Delgado',
    completionNote: 'Updated with Monday staffing changes and safety bulletin',
    completionType: 'checkbox',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 10,
    criticalityTier: 'B',
  },
  // ── In Progress (3) ──
  {
    id: 'inst-20260331-003',
    taskId: 'task-001',
    taskName: 'Review Incident Events',
    domain: 'quality',
    dueDate: '2026-04-13',
    dueTime: '07:00',
    status: 'in_progress',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox_note',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 15,
    criticalityTier: 'A',
  },
  {
    id: 'inst-20260331-004',
    taskId: 'task-025',
    taskName: 'Primary Care Huddle Prep',
    domain: 'operations',
    dueDate: '2026-04-13',
    dueTime: '07:00',
    status: 'in_progress',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox_note',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 15,
    criticalityTier: 'A',
  },
  {
    id: 'inst-20260331-005',
    taskId: 'task-031',
    taskName: 'In-Basket Review',
    domain: 'communications',
    dueDate: '2026-04-13',
    dueTime: '07:00',
    status: 'in_progress',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox_note',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 30,
    criticalityTier: 'A',
  },
  // ── Overdue (2) ──
  {
    id: 'inst-20260331-006',
    taskId: 'task-008',
    taskName: 'Daily Attendance Tracking',
    domain: 'staffing',
    dueDate: '2026-04-13',
    dueTime: '06:30',
    status: 'overdue',
    ownerRole: 'charge_nurse',
    resolvedOwner: { name: 'James Rodriguez', id: 'user-james' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox_note',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 52,
    estimatedMinutes: 20,
    criticalityTier: 'A',
  },
  {
    id: 'inst-20260331-007',
    taskId: 'task-016',
    taskName: '2nd BP Compliance',
    domain: 'access',
    dueDate: '2026-04-13',
    dueTime: '08:30',
    status: 'overdue',
    ownerRole: 'triage_rn',
    resolvedOwner: { name: 'Sarah Chen', id: 'user-sarah' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 26,
    estimatedMinutes: 10,
    criticalityTier: 'B',
  },
  // ── Delegated (1) ──
  {
    id: 'inst-20260331-008',
    taskId: 'task-017',
    taskName: 'Eyewash Station Checklist',
    domain: 'compliance',
    dueDate: '2026-04-13',
    dueTime: '07:00',
    status: 'delegated',
    ownerRole: 'charge_nurse',
    resolvedOwner: { name: 'James Rodriguez', id: 'user-james' },
    delegatedTo: { name: 'Mike Johnson', id: 'user-mike' },
    delegationHistory: [{ from: 'James Rodriguez', to: 'Mike Johnson', at: '2026-04-13T06:30:00Z', reason: 'James covering ER overflow' }],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 10,
    criticalityTier: 'B',
  },
  // ── Skipped (1) ──
  {
    id: 'inst-20260331-009',
    taskId: 'task-005',
    taskName: 'Pediatric Dashboard Review',
    domain: 'quality',
    dueDate: '2026-04-13',
    dueTime: '07:45',
    status: 'skipped',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox',
    linkedOutputs: [],
    skipReason: 'Tableau server maintenance — dashboard unavailable until 12:00',
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 10,
    criticalityTier: 'C',
  },
  // ── Orphaned (1) ──
  {
    id: 'inst-20260331-010',
    taskId: 'task-013',
    taskName: 'Encounter Closure Review',
    domain: 'access',
    dueDate: '2026-04-13',
    dueTime: '16:00',
    status: 'pending',
    ownerRole: 'front_desk',
    resolvedOwner: null,
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox_note',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: true,
    overdueHours: 0,
    estimatedMinutes: 20,
    criticalityTier: 'B',
  },
  // ── Pending (8) ──
  {
    id: 'inst-20260331-011',
    taskId: 'task-002',
    taskName: 'HTN Dashboard Review',
    domain: 'quality',
    dueDate: '2026-04-13',
    dueTime: '07:15',
    status: 'pending',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 10,
    criticalityTier: 'B',
  },
  {
    id: 'inst-20260331-012',
    taskId: 'task-004',
    taskName: 'OB Dashboard Review',
    domain: 'quality',
    dueDate: '2026-04-13',
    dueTime: '07:30',
    status: 'pending',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 10,
    criticalityTier: 'B',
  },
  {
    id: 'inst-20260331-013',
    taskId: 'task-026',
    taskName: 'Rounding',
    domain: 'operations',
    dueDate: '2026-04-13',
    dueTime: '09:00',
    status: 'pending',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox_note',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 90,
    criticalityTier: 'A',
  },
  {
    id: 'inst-20260331-014',
    taskId: 'task-020',
    taskName: 'LMS Compliance Check',
    domain: 'compliance',
    dueDate: '2026-04-13',
    dueTime: '11:00',
    status: 'pending',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 10,
    criticalityTier: 'C',
  },
  {
    id: 'inst-20260331-015',
    taskId: 'task-010',
    taskName: 'Vacancy Spreadsheet Update',
    domain: 'staffing',
    dueDate: '2026-04-13',
    dueTime: '11:00',
    status: 'pending',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox_note',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 15,
    criticalityTier: 'C',
  },
  {
    id: 'inst-20260331-016',
    taskId: 'task-014',
    taskName: 'W15 Reports Review',
    domain: 'access',
    dueDate: '2026-04-13',
    dueTime: '09:30',
    status: 'pending',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 15,
    criticalityTier: 'C',
  },
  {
    id: 'inst-20260331-017',
    taskId: 'task-032',
    taskName: 'Email Quality Review',
    domain: 'communications',
    dueDate: '2026-04-13',
    dueTime: '15:00',
    status: 'pending',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 20,
    criticalityTier: 'C',
  },
  {
    id: 'inst-20260331-018',
    taskId: 'task-009',
    taskName: 'Staffing Schedule Build',
    domain: 'staffing',
    dueDate: '2026-04-13',
    dueTime: '14:00',
    status: 'pending',
    ownerRole: 'com',
    resolvedOwner: { name: 'Maria Delgado', id: 'user-maria' },
    delegatedTo: null,
    delegationHistory: [],
    completedAt: null,
    completedBy: null,
    completionNote: null,
    completionType: 'checkbox_linked',
    linkedOutputs: [],
    skipReason: null,
    isOrphaned: false,
    overdueHours: 0,
    estimatedMinutes: 45,
    criticalityTier: 'A',
  },
];

export const mockPMChecklists = [
  {
    id: 'cl-001',
    name: 'Monthly Safety Inspection',
    domain: 'safety',
    cadence: 'monthly',
    regulatorySource: 'osha',
    stepsTotal: 8,
    stepsCompleted: 5,
    dueDate: '2026-04-15',
    estimatedMinutesPerStep: 6,
    lastCompletedDate: '2026-02-28',
    steps: [
      { id: 'step-1', description: 'Inspect fire extinguisher tags and pressure gauges', requiresNote: false, assignee: null, completed: true, completedAt: '2026-04-13T08:00:00Z', completedBy: 'Maria Delgado', note: '' },
      { id: 'step-2', description: 'Verify emergency exit signage illumination and unobstructed pathways', requiresNote: false, assignee: null, completed: true, completedAt: '2026-04-13T08:10:00Z', completedBy: 'Maria Delgado', note: '' },
      { id: 'step-3', description: 'Check electrical panel access clearance (36-inch minimum)', requiresNote: true, assignee: null, completed: true, completedAt: '2026-04-13T08:15:00Z', completedBy: 'Maria Delgado', note: 'Panel B in storage closet had boxes stacked — cleared and documented' },
      { id: 'step-4', description: 'Test emergency lighting battery backup', requiresNote: false, assignee: null, completed: true, completedAt: '2026-04-13T08:25:00Z', completedBy: 'Maria Delgado', note: '' },
      { id: 'step-5', description: 'Inspect slip/trip hazards in patient areas and hallways', requiresNote: true, assignee: null, completed: true, completedAt: '2026-04-13T08:35:00Z', completedBy: 'James Rodriguez', note: 'Loose floor tile in exam room 3 — work order submitted' },
      { id: 'step-6', description: 'Verify sharps container fill levels (replace at 3/4 full)', requiresNote: false, assignee: 'James Rodriguez', completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-7', description: 'Check AED unit battery indicator and pad expiration dates', requiresNote: true, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-8', description: 'Review and update posted emergency contact numbers', requiresNote: false, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
    ],
    completionHistory: [
      { date: '2026-02-28', completedBy: 'Maria Delgado', stepsCompleted: 8, totalSteps: 8, duration: '45 min' },
      { date: '2026-01-31', completedBy: 'Maria Delgado', stepsCompleted: 8, totalSteps: 8, duration: '50 min' },
    ],
    attachments: [],
  },
  {
    id: 'cl-002',
    name: 'Quarterly Fire Drill Documentation',
    domain: 'safety',
    cadence: 'quarterly',
    regulatorySource: 'joint_commission',
    stepsTotal: 6,
    stepsCompleted: 0,
    dueDate: '2026-04-14',
    estimatedMinutesPerStep: 15,
    lastCompletedDate: '2025-12-15',
    steps: [
      { id: 'step-1', description: 'Schedule fire drill with local fire department liaison', requiresNote: true, assignee: 'Maria Delgado', completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-2', description: 'Notify all department heads of drill date and time window', requiresNote: false, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-3', description: 'Conduct drill and record evacuation time per zone', requiresNote: true, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-4', description: 'Document staff participation roster and attendance percentage', requiresNote: true, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-5', description: 'Identify deficiencies and create corrective action items', requiresNote: true, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-6', description: 'Submit completed drill report to Safety Committee', requiresNote: false, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
    ],
    completionHistory: [
      { date: '2025-12-15', completedBy: 'Maria Delgado', stepsCompleted: 6, totalSteps: 6, duration: '90 min' },
      { date: '2025-09-20', completedBy: 'Nina Patel', stepsCompleted: 6, totalSteps: 6, duration: '85 min' },
    ],
    attachments: [],
  },
  {
    id: 'cl-003',
    name: 'Weekly Eyewash Station Check',
    domain: 'compliance',
    cadence: 'weekly',
    regulatorySource: 'osha',
    stepsTotal: 4,
    stepsCompleted: 4,
    dueDate: '2026-04-07',
    estimatedMinutesPerStep: 3,
    lastCompletedDate: '2026-03-24',
    steps: [
      { id: 'step-1', description: 'Flush eyewash station for 3 minutes to clear stagnant water', requiresNote: false, assignee: null, completed: true, completedAt: '2026-04-13T07:00:00Z', completedBy: 'James Rodriguez', note: '' },
      { id: 'step-2', description: 'Verify water temperature is between 60-100 degrees F', requiresNote: true, assignee: null, completed: true, completedAt: '2026-04-13T07:05:00Z', completedBy: 'James Rodriguez', note: 'Measured 72F — within range' },
      { id: 'step-3', description: 'Check for debris or contamination in basin and nozzles', requiresNote: false, assignee: null, completed: true, completedAt: '2026-04-13T07:07:00Z', completedBy: 'James Rodriguez', note: '' },
      { id: 'step-4', description: 'Sign and date the posted inspection tag', requiresNote: false, assignee: null, completed: true, completedAt: '2026-04-13T07:08:00Z', completedBy: 'James Rodriguez', note: '' },
    ],
    completionHistory: [
      { date: '2026-03-24', completedBy: 'James Rodriguez', stepsCompleted: 4, totalSteps: 4, duration: '10 min' },
      { date: '2026-03-17', completedBy: 'James Rodriguez', stepsCompleted: 4, totalSteps: 4, duration: '12 min' },
      { date: '2026-03-10', completedBy: 'Mike Johnson', stepsCompleted: 4, totalSteps: 4, duration: '10 min' },
    ],
    attachments: [],
  },
  {
    id: 'cl-004',
    name: 'Monthly Medication Storage Audit',
    domain: 'quality',
    cadence: 'monthly',
    regulatorySource: 'joint_commission',
    stepsTotal: 10,
    stepsCompleted: 3,
    dueDate: '2026-04-14',
    estimatedMinutesPerStep: 6,
    lastCompletedDate: '2026-02-28',
    steps: [
      { id: 'step-1', description: 'Verify refrigerator temperature logs are current and within 36-46 degrees F', requiresNote: true, assignee: null, completed: true, completedAt: '2026-04-13T08:00:00Z', completedBy: 'Sarah Chen', note: 'All units within range — logs current through today' },
      { id: 'step-2', description: 'Check all medication expiration dates and remove expired items', requiresNote: true, assignee: null, completed: true, completedAt: '2026-04-13T08:20:00Z', completedBy: 'Sarah Chen', note: 'Found 2 expired albuterol nebulizer vials — removed and logged' },
      { id: 'step-3', description: 'Verify controlled substance count matches logbook entries', requiresNote: true, assignee: null, completed: true, completedAt: '2026-04-13T08:40:00Z', completedBy: 'Sarah Chen', note: 'All counts verified — no discrepancies' },
      { id: 'step-4', description: 'Inspect medication storage areas for proper labeling and organization', requiresNote: false, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-5', description: 'Verify look-alike/sound-alike medications are stored separately with warning labels', requiresNote: true, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-6', description: 'Check emergency medication kit seal integrity and expiration', requiresNote: false, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-7', description: 'Verify multi-dose vial beyond-use dates are marked', requiresNote: false, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-8', description: 'Inspect sample medication closet for proper documentation', requiresNote: true, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-9', description: 'Review medication disposal log for completeness', requiresNote: false, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-10', description: 'Submit audit summary to pharmacy liaison', requiresNote: false, assignee: 'Maria Delgado', completed: false, completedAt: null, completedBy: null, note: '' },
    ],
    completionHistory: [
      { date: '2026-02-28', completedBy: 'Sarah Chen', stepsCompleted: 10, totalSteps: 10, duration: '55 min' },
      { date: '2026-01-31', completedBy: 'Sarah Chen', stepsCompleted: 10, totalSteps: 10, duration: '60 min' },
    ],
    attachments: [],
  },
  {
    id: 'cl-005',
    name: 'New Employee Onboarding Checklist',
    domain: 'operations',
    cadence: 'monthly',
    regulatorySource: null,
    stepsTotal: 12,
    stepsCompleted: 7,
    dueDate: '2026-04-20',
    estimatedMinutesPerStep: 10,
    lastCompletedDate: '2026-02-15',
    steps: [
      { id: 'step-1', description: 'Verify new hire paperwork completion in HR system', requiresNote: false, assignee: 'Maria Delgado', completed: true, completedAt: '2026-03-24T09:00:00Z', completedBy: 'Maria Delgado', note: '' },
      { id: 'step-2', description: 'Set up Epic access credentials and role-based permissions', requiresNote: true, assignee: null, completed: true, completedAt: '2026-03-24T09:30:00Z', completedBy: 'Maria Delgado', note: 'Access provisioned — MA role template applied' },
      { id: 'step-3', description: 'Assign mandatory LMS training modules and set due dates', requiresNote: false, assignee: null, completed: true, completedAt: '2026-03-24T10:00:00Z', completedBy: 'Maria Delgado', note: '' },
      { id: 'step-4', description: 'Schedule orientation tour of facility with charge nurse', requiresNote: false, assignee: 'James Rodriguez', completed: true, completedAt: '2026-03-25T08:00:00Z', completedBy: 'James Rodriguez', note: '' },
      { id: 'step-5', description: 'Issue badge, keys, and supply access to new hire', requiresNote: true, assignee: 'Amy Park', completed: true, completedAt: '2026-03-25T10:00:00Z', completedBy: 'Amy Park', note: 'Badge #4821 issued' },
      { id: 'step-6', description: 'Review emergency procedures and evacuation routes', requiresNote: false, assignee: null, completed: true, completedAt: '2026-03-25T11:00:00Z', completedBy: 'James Rodriguez', note: '' },
      { id: 'step-7', description: 'Complete HIPAA privacy and security attestation', requiresNote: false, assignee: null, completed: true, completedAt: '2026-03-26T09:00:00Z', completedBy: 'Maria Delgado', note: '' },
      { id: 'step-8', description: 'Assign preceptor for first two weeks of clinical orientation', requiresNote: true, assignee: 'Maria Delgado', completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-9', description: 'Schedule N95 fit testing appointment', requiresNote: false, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-10', description: 'Verify BLS/ACLS certification currency', requiresNote: true, assignee: null, completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-11', description: 'Add new hire to unit communication distribution lists', requiresNote: false, assignee: 'Amy Park', completed: false, completedAt: null, completedBy: null, note: '' },
      { id: 'step-12', description: 'Schedule 30-day check-in meeting with COM', requiresNote: false, assignee: 'Maria Delgado', completed: false, completedAt: null, completedBy: null, note: '' },
    ],
    completionHistory: [
      { date: '2026-02-15', completedBy: 'Maria Delgado', stepsCompleted: 12, totalSteps: 12, duration: '3 hours' },
    ],
    attachments: [],
  },
];

export const mockPMStaffRoster = [
  { id: 'user-maria', name: 'Maria Delgado', role: 'com', credentials: ['RN', 'MBA'], available: true },
  { id: 'user-sarah', name: 'Sarah Chen', role: 'triage_rn', credentials: ['RN', 'BSN'], available: true },
  { id: 'user-james', name: 'James Rodriguez', role: 'charge_nurse', credentials: ['RN', 'BSN', 'ACLS'], available: true },
  { id: 'user-amy', name: 'Amy Park', role: 'front_desk', credentials: [], available: true },
  { id: 'user-david', name: 'David Kim', role: 'scheduling_coord', credentials: [], available: true },
  { id: 'user-lisa', name: 'Lisa Thompson', role: 'triage_rn', credentials: ['RN', 'BSN'], available: false },
  { id: 'user-mike', name: 'Mike Johnson', role: 'charge_nurse', credentials: ['RN', 'ACLS'], available: true },
  { id: 'user-nina', name: 'Nina Patel', role: 'com', credentials: ['RN', 'MBA', 'CPHQ'], available: true },
];

export const mockPMOverviewMetrics = {
  'unit-main-st': {
    completionRate: { value: 87, target: 95, trend: -3, trendLabel: '\u2193 3% vs last week' },
    overdueCount: { value: 4, trend: 2, trendLabel: '\u2191 2 vs last week' },
    skipRate: { value: 8, trend: 1, trendLabel: '\u2191 1% vs last week' },
    avgCompletionTime: { value: 22, unit: 'min', trend: -2, trendLabel: '\u2193 2 min vs last week' },
    tasksToday: { total: 18, completed: 5, pending: 8, inProgress: 3, overdue: 2 },
    domainBreakdown: [
      { domain: 'quality', completionRate: 90, taskCount: 5, completedCount: 2, pendingCount: 1, inProgressCount: 1, overdueCount: 1 },
      { domain: 'staffing', completionRate: 80, taskCount: 3, completedCount: 1, pendingCount: 1, inProgressCount: 0, overdueCount: 1 },
      { domain: 'access', completionRate: 85, taskCount: 3, completedCount: 1, pendingCount: 1, inProgressCount: 1, overdueCount: 0 },
      { domain: 'compliance', completionRate: 100, taskCount: 2, completedCount: 0, pendingCount: 2, inProgressCount: 0, overdueCount: 0 },
      { domain: 'safety', completionRate: 75, taskCount: 2, completedCount: 0, pendingCount: 1, inProgressCount: 1, overdueCount: 0 },
      { domain: 'operations', completionRate: 85, taskCount: 2, completedCount: 1, pendingCount: 1, inProgressCount: 0, overdueCount: 0 },
      { domain: 'finance', completionRate: 100, taskCount: 1, completedCount: 0, pendingCount: 1, inProgressCount: 0, overdueCount: 0 },
    ],
    ownershipSummary: [
      {
        role: 'com', individual: 'Maria Delgado', isOrphaned: false,
        byPeriod: {
          today:     { daily: { assigned: 5, completed: 2, overdue: 0 }, weekly: { assigned: 2, completed: 1, overdue: 0 }, monthly: { assigned: 1, completed: 0, overdue: 1 } },
          thisWeek:  { daily: { assigned: 22, completed: 18, overdue: 1 }, weekly: { assigned: 4, completed: 3, overdue: 0 }, monthly: { assigned: 2, completed: 1, overdue: 1 } },
          thisMonth: { daily: { assigned: 88, completed: 78, overdue: 3 }, weekly: { assigned: 12, completed: 10, overdue: 1 }, monthly: { assigned: 4, completed: 3, overdue: 1 } },
        },
        tasks: [
          { id: 'ot-m-1', taskName: 'Review Incident Events', domain: 'quality', dueDate: '2026-04-13', dueTime: '09:00', status: 'completed', cadence: 'daily', completionType: 'checkbox_note', estimatedMinutes: 18 },
          { id: 'ot-m-2', taskName: 'Huddle Board Update', domain: 'operations', dueDate: '2026-04-13', dueTime: '07:30', status: 'completed', cadence: 'daily', completionType: 'checkbox', estimatedMinutes: 8 },
          { id: 'ot-m-3', taskName: 'In-Basket Review', domain: 'quality', dueDate: '2026-04-13', dueTime: '10:00', status: 'pending', cadence: 'daily', completionType: 'checkbox_note', estimatedMinutes: 35 },
          { id: 'ot-m-4', taskName: 'Staff Schedule Build', domain: 'staffing', dueDate: '2026-04-13', dueTime: '14:00', status: 'pending', cadence: 'daily', completionType: 'checkbox_linked', estimatedMinutes: 45 },
          { id: 'ot-m-5', taskName: 'Patient Callback Follow-up', domain: 'access', dueDate: '2026-04-13', dueTime: '11:00', status: 'pending', cadence: 'daily', completionType: 'checkbox', estimatedMinutes: 20 },
          { id: 'ot-m-6', taskName: 'Weekly Compliance Review', domain: 'compliance', dueDate: '2026-04-13', dueTime: '15:00', status: 'pending', cadence: 'weekly', completionType: 'checkbox_note', estimatedMinutes: 30 },
          { id: 'ot-m-7', taskName: 'Provider Availability Update', domain: 'staffing', dueDate: '2026-04-13', dueTime: '08:00', status: 'pending', cadence: 'weekly', completionType: 'checkbox', estimatedMinutes: 15 },
          { id: 'ot-m-8', taskName: 'Monthly Medication Storage Audit', domain: 'quality', dueDate: '2026-04-14', dueTime: '09:00', status: 'overdue', cadence: 'monthly', completionType: 'checkbox_note', estimatedMinutes: 55 },
        ],
      },
      {
        role: 'triage_rn', individual: 'Sarah Chen', isOrphaned: false,
        byPeriod: {
          today:     { daily: { assigned: 2, completed: 1, overdue: 1 }, weekly: { assigned: 1, completed: 0, overdue: 0 }, monthly: { assigned: 0, completed: 0, overdue: 0 } },
          thisWeek:  { daily: { assigned: 10, completed: 8, overdue: 2 }, weekly: { assigned: 2, completed: 1, overdue: 0 }, monthly: { assigned: 1, completed: 0, overdue: 0 } },
          thisMonth: { daily: { assigned: 40, completed: 35, overdue: 4 }, weekly: { assigned: 6, completed: 5, overdue: 1 }, monthly: { assigned: 2, completed: 1, overdue: 0 } },
        },
        tasks: [
          { id: 'ot-s-1', taskName: 'Temperature Monitoring', domain: 'safety', dueDate: '2026-04-13', dueTime: '06:45', status: 'completed', cadence: 'daily', completionType: 'checkbox', estimatedMinutes: 5 },
          { id: 'ot-s-2', taskName: 'Triage Protocol Check', domain: 'quality', dueDate: '2026-04-13', dueTime: '08:00', status: 'overdue', cadence: 'daily', completionType: 'checkbox_note', estimatedMinutes: 10 },
          { id: 'ot-s-3', taskName: 'Eyewash Station Flush', domain: 'compliance', dueDate: '2026-04-13', dueTime: '07:00', status: 'pending', cadence: 'weekly', completionType: 'checkbox', estimatedMinutes: 12 },
        ],
      },
      {
        role: 'charge_nurse', individual: 'James Rodriguez', isOrphaned: false,
        byPeriod: {
          today:     { daily: { assigned: 1, completed: 0, overdue: 0 }, weekly: { assigned: 1, completed: 0, overdue: 0 }, monthly: { assigned: 0, completed: 0, overdue: 0 } },
          thisWeek:  { daily: { assigned: 5, completed: 4, overdue: 0 }, weekly: { assigned: 2, completed: 1, overdue: 0 }, monthly: { assigned: 1, completed: 0, overdue: 0 } },
          thisMonth: { daily: { assigned: 20, completed: 18, overdue: 1 }, weekly: { assigned: 8, completed: 7, overdue: 0 }, monthly: { assigned: 2, completed: 2, overdue: 0 } },
        },
        tasks: [
          { id: 'ot-j-1', taskName: 'Sharps Container Check', domain: 'safety', dueDate: '2026-04-13', dueTime: '08:30', status: 'pending', cadence: 'daily', completionType: 'checkbox', estimatedMinutes: 10 },
          { id: 'ot-j-2', taskName: 'AED Battery Inspection', domain: 'safety', dueDate: '2026-04-13', dueTime: '09:00', status: 'pending', cadence: 'weekly', completionType: 'checkbox_note', estimatedMinutes: 15 },
        ],
      },
      {
        role: 'front_desk', individual: null, isOrphaned: true,
        byPeriod: {
          today:     { daily: { assigned: 1, completed: 0, overdue: 0 }, weekly: { assigned: 0, completed: 0, overdue: 0 }, monthly: { assigned: 0, completed: 0, overdue: 0 } },
          thisWeek:  { daily: { assigned: 5, completed: 0, overdue: 3 }, weekly: { assigned: 1, completed: 0, overdue: 1 }, monthly: { assigned: 0, completed: 0, overdue: 0 } },
          thisMonth: { daily: { assigned: 20, completed: 0, overdue: 15 }, weekly: { assigned: 4, completed: 0, overdue: 3 }, monthly: { assigned: 1, completed: 0, overdue: 1 } },
        },
        tasks: [
          { id: 'ot-f-1', taskName: 'Patient Check-in Verification', domain: 'access', dueDate: '2026-04-13', dueTime: '07:00', status: 'pending', cadence: 'daily', completionType: 'checkbox', estimatedMinutes: 5 },
        ],
      },
    ],
    weeklyTrend: [
      { week: 'W10', completionRate: 92 },
      { week: 'W11', completionRate: 89 },
      { week: 'W12', completionRate: 90 },
      { week: 'W13', completionRate: 87 },
    ],
  },
};

export const mockPMCompletionHistory = [
  { id: 'comp-001', taskName: 'Review Incident Events', domain: 'quality', dueDate: '2026-04-13', completionDate: '2026-04-13', timeToCompletion: 18, completedBy: 'Maria Delgado', completionType: 'checkbox_note', note: 'Two near-miss events documented and escalated', overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-002', taskName: 'Temperature Monitoring', domain: 'safety', dueDate: '2026-04-13', completionDate: '2026-04-13', timeToCompletion: 4, completedBy: 'Sarah Chen', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-003', taskName: 'Huddle Board Update', domain: 'operations', dueDate: '2026-04-13', completionDate: '2026-04-13', timeToCompletion: 8, completedBy: 'Maria Delgado', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-004', taskName: 'In-Basket Review', domain: 'communications', dueDate: '2026-03-30', completionDate: '2026-03-30', timeToCompletion: 35, completedBy: 'Maria Delgado', completionType: 'checkbox_note', note: 'Heavy volume — 42 messages processed', overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-005', taskName: 'Primary Care Huddle Prep', domain: 'operations', dueDate: '2026-03-30', completionDate: '2026-03-30', timeToCompletion: 12, completedBy: 'Maria Delgado', completionType: 'checkbox_note', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-006', taskName: 'HTN Dashboard Review', domain: 'quality', dueDate: '2026-03-30', completionDate: '2026-03-30', timeToCompletion: 8, completedBy: 'Maria Delgado', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-007', taskName: 'OB Dashboard Review', domain: 'quality', dueDate: '2026-03-30', completionDate: '2026-03-30', timeToCompletion: 10, completedBy: 'Maria Delgado', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-008', taskName: 'Daily Attendance Tracking', domain: 'staffing', dueDate: '2026-03-30', completionDate: '2026-03-30', timeToCompletion: 25, completedBy: 'James Rodriguez', completionType: 'checkbox_note', note: 'One call-out — float pool notified', overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-009', taskName: 'Rounding', domain: 'operations', dueDate: '2026-03-30', completionDate: '2026-03-30', timeToCompletion: 85, completedBy: 'Maria Delgado', completionType: 'checkbox_note', note: 'Staff morale concerns noted in triage area', overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-010', taskName: 'Encounter Closure Review', domain: 'access', dueDate: '2026-03-29', completionDate: '2026-03-30', timeToCompletion: 22, completedBy: 'Maria Delgado', completionType: 'checkbox_note', note: null, overdueIndicator: true, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-011', taskName: 'Eyewash Station Checklist', domain: 'compliance', dueDate: '2026-03-29', completionDate: '2026-03-29', timeToCompletion: 10, completedBy: 'James Rodriguez', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-012', taskName: 'Review Incident Events', domain: 'quality', dueDate: '2026-03-29', completionDate: '2026-03-29', timeToCompletion: 15, completedBy: 'Maria Delgado', completionType: 'checkbox_note', note: 'No new events', overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-013', taskName: 'Pediatric Dashboard Review', domain: 'quality', dueDate: '2026-03-28', completionDate: null, timeToCompletion: null, completedBy: null, completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: true, skipCount30d: 4 },
  { id: 'comp-014', taskName: 'W15 Reports Review', domain: 'access', dueDate: '2026-03-28', completionDate: '2026-03-28', timeToCompletion: 14, completedBy: 'Maria Delgado', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-015', taskName: 'LMS Compliance Check', domain: 'compliance', dueDate: '2026-03-28', completionDate: '2026-03-28', timeToCompletion: 8, completedBy: 'Maria Delgado', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-016', taskName: 'Backsweep Reports', domain: 'access', dueDate: '2026-03-28', completionDate: null, timeToCompletion: null, completedBy: null, completionType: 'checkbox_note', note: null, overdueIndicator: false, skipIndicator: true, skipCount30d: 3 },
  { id: 'comp-017', taskName: 'Temperature Monitoring', domain: 'safety', dueDate: '2026-03-28', completionDate: '2026-03-28', timeToCompletion: 5, completedBy: 'Sarah Chen', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-018', taskName: 'Huddle Board Update', domain: 'operations', dueDate: '2026-03-28', completionDate: '2026-03-28', timeToCompletion: 10, completedBy: 'Maria Delgado', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-019', taskName: 'Vacancy Spreadsheet Update', domain: 'staffing', dueDate: '2026-03-27', completionDate: '2026-03-28', timeToCompletion: 18, completedBy: 'Maria Delgado', completionType: 'checkbox_note', note: null, overdueIndicator: true, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-020', taskName: 'Email Quality Review', domain: 'communications', dueDate: '2026-03-27', completionDate: null, timeToCompletion: null, completedBy: null, completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: true, skipCount30d: 5 },
  { id: 'comp-021', taskName: '2nd BP Compliance', domain: 'access', dueDate: '2026-03-27', completionDate: '2026-03-27', timeToCompletion: 10, completedBy: 'Sarah Chen', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-022', taskName: 'MTHA Completion Review', domain: 'quality', dueDate: '2026-03-26', completionDate: '2026-03-26', timeToCompletion: 22, completedBy: 'Maria Delgado', completionType: 'checkbox_note', note: 'Three providers below 80% target — outreach emails sent', overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-023', taskName: 'DRS Readability Check', domain: 'quality', dueDate: '2026-03-26', completionDate: '2026-03-26', timeToCompletion: 16, completedBy: 'Maria Delgado', completionType: 'checkbox_linked', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-024', taskName: 'Staffing Schedule Build', domain: 'staffing', dueDate: '2026-03-25', completionDate: '2026-03-25', timeToCompletion: 48, completedBy: 'Maria Delgado', completionType: 'checkbox_linked', note: 'Short one RN on Thursday — float requested', overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
  { id: 'comp-025', taskName: 'Outreach Performance Review', domain: 'communications', dueDate: '2026-03-24', completionDate: '2026-03-24', timeToCompletion: 14, completedBy: 'Maria Delgado', completionType: 'checkbox', note: null, overdueIndicator: false, skipIndicator: false, skipCount30d: 0 },
];

const _directorPMServiceLineData = {
  practices: [
    { unitId: 'unit-main-st', name: 'Main St Clinic', completionRate: 87, overdueCount: 4, skipRate: 8, trend: 'down', orphanedEvents: 1 },
    { unitId: 'unit-downtown', name: 'Downtown Clinic', completionRate: 92, overdueCount: 2, skipRate: 3, trend: 'up', orphanedEvents: 0 },
    { unitId: 'unit-westside', name: 'Westside Family Practice', completionRate: 78, overdueCount: 7, skipRate: 15, trend: 'down', orphanedEvents: 3 },
    { unitId: 'unit-north', name: 'North Medical Center', completionRate: 95, overdueCount: 1, skipRate: 2, trend: 'up', orphanedEvents: 0 },
    { unitId: 'unit-south', name: 'Southgate Health Center', completionRate: 82, overdueCount: 5, skipRate: 10, trend: 'down', orphanedEvents: 2 },
    { unitId: 'unit-east', name: 'Eastlake Urgent Care', completionRate: 88, overdueCount: 3, skipRate: 6, trend: 'up', orphanedEvents: 1 },
  ],
  aggregated: { avgCompletionRate: 87, totalOverdue: 22, practicesBelowThreshold: 2, threshold: 80 },
  orphanedEvents: [
    { id: 'oe-001', practiceId: 'unit-westside', practiceName: 'Westside Family Practice', role: 'Triage RN', tasksOrphaned: 4, timestamp: '2026-04-13T08:15:00Z', resolved: false, resolvedAt: null },
    { id: 'oe-002', practiceId: 'unit-westside', practiceName: 'Westside Family Practice', role: 'Front Desk Lead', tasksOrphaned: 2, timestamp: '2026-03-30T07:00:00Z', resolved: true, resolvedAt: '2026-03-30T09:30:00Z' },
    { id: 'oe-003', practiceId: 'unit-south', practiceName: 'Southgate Health Center', role: 'Charge Nurse', tasksOrphaned: 3, timestamp: '2026-03-29T06:45:00Z', resolved: true, resolvedAt: '2026-03-29T08:00:00Z' },
    { id: 'oe-004', practiceId: 'unit-south', practiceName: 'Southgate Health Center', role: 'Triage RN', tasksOrphaned: 5, timestamp: '2026-03-28T07:30:00Z', resolved: true, resolvedAt: '2026-03-28T10:15:00Z' },
    { id: 'oe-005', practiceId: 'unit-main-st', practiceName: 'Main St Clinic', role: 'Front Desk Lead', tasksOrphaned: 1, timestamp: '2026-03-27T06:30:00Z', resolved: true, resolvedAt: '2026-03-27T07:45:00Z' },
  ],
};

export const mockDirectorPMMetrics = {
  'service-line-primary-care': _directorPMServiceLineData,
  'region-primary-care': _directorPMServiceLineData,
};
